//import { ContactSupportOutlined, LocalConvenienceStoreOutlined, SettingsRemoteRounded } from '@material-ui/icons';
//import { instanceOf } from 'prop-types';
import { HISTORY, 
		 STATS,
		 CONSTS,
         console_log,
		 INFO } from '../util/object'
import { VIMEO_POST,
         YOUTUBE_POST } from "../util/constants";
import { dbUpdateTutorialState,
         dbCheckInviteKey, 
         startUser, 
         getServerVersion,
         makeUserKey,
         inviteUser, 
         makeUserHash,
         ReadMenuData,
         ReadStateData,
         ReadHomeOrgData, 
         CreateVirtualSession,
         ReadLeaderData } from '../util/database';
import { setOffsetHeight } from "../util/tools";
import { AXOS_VERSION } from '../version';
import { AuthClass,
         checkAuthResponse } from '../class/AuthClass';
import { writeGifFile } from '../util/videoUtil';
import { UtilClass } from '../class/UtilClass';

import gifshot from 'gifshot';
const Util = new UtilClass();
var auth = new AuthClass();


export const NOW = (Date.now() % 100000 / 1000);

// CONVERSION TABLE FROM SLOPE TO DEGREES
// src: https://docs.google.com/spreadsheets/d/1m-fPf3FZagQ8qUHXlfiecutITgidO3pi671524ne5Zg/edit#gid=1239175284
const X=[ 0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200,
		  0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200,
		  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
		  200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200]
const Y=[ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
		  200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200,
		  0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200,
		  0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200]
const D=[ 315, 318, 321, 325, 329, 333, 338, 343, 349, 354, 360, 6, 11, 17, 22, 27, 31, 35, 39, 42, 45,
		  225, 222, 219, 215, 211, 207, 202, 197, 191, 186, 180, 174, 169, 163, 158, 153, 149, 145, 141, 138, 135,
		  315, 312, 309, 305, 301, 297, 292, 287, 281, 276, 270, 264, 259, 253, 248, 243, 239, 235, 231, 228, 225,
		  45, 48, 51, 55, 59, 63, 68, 73, 79, 84, 90, 96, 101, 107, 112, 117, 121, 125, 129, 132, 135]

var last_timestamp = 0;

const FEMUR_CNT = 200;		// bkt_width = canvas.width / FEMUR_CNT
export var FEMUR=[];	// Hash table [Y_BKT][data]

// create slope -> degree lookup table
// Both X & Y need to be normalized to between (-1, 1), then add 1, then mult 100
// this creates the index to look up the array 
// 
var DEGREE = []
export function initTables() {
	var i, x, y;
	for (i = 0; i < 201; i++) {
		DEGREE[i] = [];
	}

	for (i = 0; i < X.length; i++) {
		x = X[i];
		y = Y[i];
		//console.log("28: x=",x, " y=",y, "  dgree=",D[i]);
		DEGREE[x][y] = D[i];
	}

	for (i = 0; i < FEMUR_CNT; i++) {
		FEMUR[i] = [];	// collect data samples
	}

	for (i = 0; i < SLOPE_BKT; i++) {
		SHIST[i] = [];	// collect data samples
	}
	FLOG = []; 
	SLOPE = [];
	POSNS = [];
	tot_scnt = 0;
}

export var SHIST = []; 		// store slope histogram
var FLOG = [];		// each femur record
var SLOPE = [];		// each slope, every permutation for statistical processing
var POSNS = [];		// pose top & bottom, one per hidx
const TOP_M = 100;
const SLOPE_BKT = 100;
//const femur_bucket_size = TOP_M / (SLOPE_BKT);
var tot_scnt = 0;


export function debugFemurStats() {
    console.log("femur.1195:       FEMUR STATS: SLOPE.len=",SLOPE.length, " SHIST.len",SHIST.length, " FLOG.len=",FLOG.length," valid_femur=",STATS.valid_femur_m_cnt);
}


// record event meta data
//
export function setFrameEvent(event) {
	var hidx = HISTORY.length -1;
	var f0 = HISTORY[hidx];

	if(f0 !== undefined) {
		f0.events.push(event);      // could be multiple
		//console.log("add_evnt.77:  hidx=",hidx, "  event=", event, "  ", f0.events, "  ", f0.timestamp);
	}
}


// input an array of objects, stores into deinfed buckets according to field
// return [ largest bucket, average of bucket, ]
//
export function analyzeHistogram(data, field, abs_sum, max_value, bucket_cnt) {
	var bkt_size = max_value / bucket_cnt;
	var buckets = [], i, val, sval, idx;
	var last = bucket_cnt - 1;
	//console.log("hist.92:  bkt_size=",bkt_size, "   bkt_cnt=",bucket_cnt, "  max_val=", max_value);

	// init buckets
	for(i=0; i < bucket_cnt; i++) {
		buckets[i] = [];
	}

	// fill bucket with data
	for(i=0; i < data.length; i++) {
		var d = data[i];
		val = d[field];
		if(val !== undefined) {
			if(val >= max_value) {
				idx = last;	// store overflow in last bucket
			} else {
				idx = Math.floor(val / bkt_size);
			}
			//console.log("hist.88: ",i, "   idx=",idx, "  val=", val, " max_val=", max_value, "  last=", last, " bkt=",buckets[idx])
			if(buckets[idx] !== undefined) {
				buckets[idx].push(d);
			} else {
				console.log("uhist.96:    BAD IDX   idx=",idx, "  val=", val, " max_val=", max_value)
			}
		} else {
			console.log("uhist.93:    FIELD NOT FOUND  f=",field, "  i=", i, " data=", d)
		}
	}

	if(buckets[last].length > (data.length * .10)) {
		//console.log("uhist.99:    MAX_VALUE ",max_value, " MAY BE TOO LOW!   ", buckets[last]);
	}

	var max_len = -1;
	var max_idx = -1;
	for(i=0; i < bucket_cnt - 1; i++) {
		// find the max bucket, do not check last one (overflow bkt)
		var bkt = buckets[i];

		//console.log("uhist.128:   BKT["+i+"] = "+bkt.length);   // UNCOMMENT TO SEE DISTRIBUTION!
		if(bkt.length > max_len) {
		    max_idx =  i;
		    max_len =  bkt.length;
		}
	}

	// determine average value in max bucket
	var mbkt = buckets[max_idx];
	var sum = 0;
	var sum_cnt = 0;
	for(i=0; i < mbkt.length; i++) {
		if(mbkt[i][field] !== undefined) {
			sval = (abs_sum === true) ? Math.abs(mbkt[i][field]) : mbkt[i][field];
			sum = sum + sval;
			sum_cnt = sum_cnt + 1;
		}
	}
	var avg = sum / sum_cnt;
	//console.log("hist.125:   max_idx=",max_idx,"  AVG_VALUE=",avg, "  bkt=",mbkt);

	return [mbkt, avg];
}


// once we have enough femur-Y slope data, determine the gold femur length
// return:  [ femur_length, @ Y ]
export function setFemurLength() {
	var i, fbkt, favg;
	var ysum = 0, ycnt = 0, yratio = 0, mmax_len = 0, mmax_i = 0;

	// determine the biggest bucket
	for (i = 0;  i < SHIST.length - 1; i++) {
		var slope = SHIST[i];
		//console.log("     ",i, "  ",slope.length, "   max=",max_i);
		if(slope.length > mmax_len) {
			mmax_len = slope.length;
			mmax_i = i;
		}
	}

	const abs_sum = true;
	const max_val = 80;
	const bucket_cnt = 100;
	[fbkt, favg] = analyzeHistogram(SHIST[mmax_i], "f", abs_sum, max_val, bucket_cnt);
	for(i=0; i < fbkt.length; i++) {
		var d = fbkt[i];
		if(Math.abs(favg - d.f) < 1) {
			ysum = ysum + d.y;
			yratio = yratio + Math.abs(d.m);
			ycnt = ycnt + 1;
		}
	}
	var yavg = Math.floor(ysum / ycnt);
	var femur_y_ratio = yratio / ycnt;
	//console.log("ubkt.167: ***** GOLDEN FEMURE  len=", favg.toFixed(2), "  y=", yavg, " ratio=", femur_y_ratio.toFixed(1), " valid_m=",STATS.valid_femur_m_cnt);
	//console.log("ubkt.168:       max_m_bkt=", SHIST[mmax_i], "  fbkt=", fbkt, " ysum=", ysum, "  ycnt=", ycnt, " yratio=",yratio);
	return [ favg, yavg, femur_y_ratio]
}




// NOTE: KLUDEG USE WAY BEFORE BLAZEPOSE WHEN RESULTS ARE BAD, sets SLOPE[], FLOGS[], POSNS[], SHIST[]
//
// - the accuracy of extract femur length determines speed accuracy
//   this ratio changes with distance to the camera, and the posenet data
//   is very glitchy, so we need a clever way to adaptively determine the
//   true length as data comes in.
// - one thing we count on is all correct femur data should obey the
//   "perspective ratio", proprotional to the distance to the lens, however
//   this ratio changes with each camera, so we only know it need to be the
//   same but we don't know "to what", here we get as many slopes as we can
//   store in histogram and find the most frequent slope
// - from there we back calculate the femur-y-ratio, and the y-distance-ratio
//     - delta_top_y / delta_bot_y
//
export function storeFemurData(canvas_y, top_y, ctr_y, bot_y, femur_length, top_prob, bot_prob) {
	var bkt = canvas_y / FEMUR_CNT;
	var idx = Math.floor(ctr_y / bkt);
	//console.log("femur.50: idx=",idx, " bkt=",bkt, " fem_len=", femur_length, " canvas_y=", canvas_y);
	if ((ctr_y <= canvas_y) && (FEMUR[idx] !== undefined) && (femur_length > 0)) {
		FEMUR[idx].push(femur_length);
	} else {
		//console.log("hist.210: BAD FEMUR DATA  y=", y," idx=", idx, " femur_len=", femur_length);
	}

	INFO.femur_bucket_size = TOP_M / SLOPE_BKT;

	var f = {}
	f.y = ctr_y;
	f.f = femur_length;
	//console.log("FLOG=", FLOG);

	// calc baby slope with every other point
	// check histogram to find the cluster, and choose that slope
	// with the slope, find the femur length at that Y
	for(var i = 0; i < FLOG.length; i++) {
		var f1 = FLOG[i];

		var s = {}
		s.top_y = top_y;        // keep for estimating camera position
		s.bot_y = bot_y;
		s.y = ctr_y;
		s.f = femur_length;
		s.dy = ctr_y - f1.y;
		s.df = femur_length - f1.f;
		s.m = (s.df / s.dy) * 100;			// change in Femur lenght over Y pixel * 100

		// create a record for each permuation, filter out malformed slopes
		//if((Math.abs(s.df) > 0) && (Math.abs(s.dy) > 1)) {
		if((Math.abs(s.df) > 5) && (Math.abs(s.dy) > 5)) {
			SLOPE.push(s)
			//console.log("SLOPE=", SLOPE);

			if ((Math.abs(s.m) < TOP_M) && (s.m !== 0)) {
				var idx = Math.floor(Math.abs(s.m) / INFO.femur_bucket_size);		// last one is overflow
				if(Math.abs(s.dy) > INFO.min_dy) {		// only use big dy
					//if(idx == 5) console.log("hist.113:        idx=",idx, "  m=",Math.floor(s.m), "  BKT=",INFO.femur_bucket_size);
					SHIST[idx].push(s);
					STATS.valid_femur_m_cnt = STATS.valid_femur_m_cnt + 1;
				} else {
					//console.log("femur.94: BAD SLOPE INDEX=", idx, " m=", Math.floor(s.m), " dy=",s.dy);
				}
			} else {
				if(s.m < 100000) {
					//console.log("femur.105: ***** OVERSIZE SLOPE INDEX=", " m=", Math.floor(s.m));
					SHIST[SHIST.length - 1].push(s);
				}
			}
		} else {
			STATS.malform_m = STATS.malform_m + 1;
		}
	}

    // store pose top and bottom for camera angle calc
    //   - do not use SLOPES[], that has too many items
    //
    if (INFO.conseq_bad_poses > 4) {
        console.log("femur.288:   ! ! ! ! ! RESET POSNS   was=".POSNS.length);
        POSNS = [];     // CLEAR IT OUT!
    } else {

        // expon smoothing
        //
        var POSN1 = POSNS[POSNS.length - 1];       // last one
        var top_ys = null, bot_ys = null;       // expon smoothing version
        var top_y0, top_y1, bot_y0, bot_y1;
        var max = INFO.webcam_oheight;
        if (POSN1) {
            top_y0 = top_y;
            top_y1 = POSN1.top_y;
            bot_y0 = bot_y;
            bot_y1 = POSN1.bot_y;
            if (top_y0 && top_y1) {
                top_ys =  Math.floor((CONSTS.EXPON_TOP_Y * top_y0) + ((1 - CONSTS.EXPON_TOP_Y) * top_y1));
            }
            if (bot_y0 && bot_y1) {
                bot_ys =  Math.floor((CONSTS.EXPON_BOT_Y * bot_y0) + ((1 - CONSTS.EXPON_BOT_Y) * bot_y1));
            }
        }

        // only sotre quality and positive data
        //    - need to special case for the first one (!bot_ys)
        //
        if (!bot_ys || ((top_prob > 90) && (bot_prob > 90) && (top_ys > 0) && (bot_ys > 0))) {
            var p = {};
            p.top_y = top_y;        // keep for estimating camera position
            p.bot_y = bot_y;
            p.top_ys = parseInt((top_ys / max ) * 100);     // normalize
            p.bot_ys = parseInt((bot_ys / max ) * 100);     // normalize
            p.top_prob = top_prob;
            p.bot_prob = bot_prob;
            POSNS.push(p);
			//console.log("322:    + + +  ADD POSN  top_ys=", p.top_ys, " bot_ys=",p.bot_ys, " top_prob=",top_prob, " bot_prob=",bot_prob, " t_ys=",top_ys, " b_ys=",bot_ys);
        }
    }

	// select the bucket with the most records
	// use the longest Y and calculate the average, this is the official femur_length
	// use equation to calculate diff femur at different Y
	// Also set the "depth" at each Y based on Dy = (L / m) + (h / m)
	if(true) {
		// display periodic progress stats
		//
		if((tot_scnt % 10) === 0) {
			var output = "";
			var shist_cnt = 0;
			for(var i = 0; i < (SHIST.length - 0); i++) {
				var slope = SHIST[i];
				if (slope.length > (shist_cnt/5)+80) {
					var sum = 0;
					for(var j = 0; j < slope.length; j++) {
						sum = sum + Math.abs(slope[j].m);
						shist_cnt = shist_cnt + 1;
					}
					output = output + "(" +i+": "+(sum/j).toFixed(2)+" " +slope.length+ ")  ";
				}
			}
			//console.log(output+"  FLOG=",FLOG.length, "  SLOPE=",SLOPE.length,"  shist_cnt=",shist_cnt);
		}
		tot_scnt = tot_scnt + 1;
	}

	FLOG.push(f);

	return STATS.valid_femur_m_cnt;
}






const MIN_POSN_SCORE = 90;      // garbage in garbage out, make sure the read is high confidence
const MAX_LOOKBACK = 20;       // 300


// determine if all the body parts are in the frame
//    - keep samples of full body posns
//
export function checkFullBody(posn) {
    var status = false;
    var max = INFO.webcam_oheight;
    //var top_y = parseInt((posn.top_ys / max ) * 100);
    //var bot_y = parseInt((posn.bot_ys / max ) * 100);
    var top_y = posn.top_ys;
    var bot_y = posn.bot_ys;

    if ((posn.top_prob > MIN_POSN_SCORE) && (posn.bot_prob > MIN_POSN_SCORE)) {
        console.log("chk_body.354:         . . . top_y=", top_y, "%   bot_y=",bot_y,"%", " top_prob=",posn.top_prob, " bot_prob=",posn.bot_prob);
    }

    return status;
}


// UTIL: look for full body posn infer camera angle
//     - ground view: [9, 68], [3, 69], [17, 73], [4, 71]
//     - tripod view: [4, 91], [9, 84]
//
// NOTE: We don't know if the camera has been moved, so need to only use the most recent
//
export function calcBodyY(hidx) {
    
    //if ((hidx < 5) || (POSNS.length < 5)) return [ null, null, null ];
    if (hidx < 5) return [ null, null, null ];

    var fpose = HISTORY[hidx].pose;
    var smooth_bot = Math.floor((CONSTS.EXPON_POSEY_MOVE * fpose.bottom0) + ((1 - CONSTS.EXPON_POSEY_MOVE) * fpose.bottom));
    var min_top = parseInt(fpose.top / INFO.image_height * 100);
    var min_bot = parseInt(smooth_bot / INFO.image_height * 100);     // return pct
    var ctr_y = parseInt(fpose.ctr_y / INFO.image_height * 100);     // return pct
    //console.log("calc_body.400:            calcBodyY  . . . hidx=",hidx, " ctr_y=", fpose.ctr_y, " bottom=",fpose.bottom, " bottom0=",fpose.bottom0, " smooth_bot=",smooth_bot, " min_bot=",min_bot);
    return [ min_top, min_bot, ctr_y, 2]




    // OLD CODE USING POSNS[]
    //
    if ((hidx < 5) || (POSNS.length < 5)) return [ null, null, null ];

    var last = POSNS.length - 1;
    var end = ((last - MAX_LOOKBACK) > 0) ? (last - MAX_LOOKBACK) : 0;   // don't go all the way back
    var min_top = 9999, min_bot = 9999;

    for (var s = last; s >= end; s--) {    // look at most recent
        var posn = POSNS[s];
        var top_y = posn.top_ys;
        var bot_y = posn.bot_ys;
        if ((hidx % 20) === 0) {
            //console.log("posn.399:       = = =  ",hidx, "-",s,":   top_ys=",top_y, "  bot_ys=",bot_y, " min_top=",min_top, " min_bot=",min_bot);
        }

        if ((bot_y < 97) && (bot_y < min_bot)) { min_top = top_y; min_bot = bot_y };        // less than 97%
    }

    //console.log("posn.406:      RETURN  ",hidx, "-",s,":   min_top=",min_top, "  min_bot=",min_bot);
    return [ min_top, min_bot, (last - end)]
}


// UTIL: extract the biggest conseq rate of change of the top of body vs. bottom of body
//     - ground view: bot chg faster than top
//     - tripod view: top chg faster than bot
//
export function calcBodyDY(hidx) {
    if ((hidx < 5) || (POSNS.length < 5)) return [ null, null, null ];

    // find the largest delta with the same direction chg (to get stronger slope signal)
    //
    var first = null;
    var last = POSNS.length - 1;
    var start = last - 1;
    var end = ((last - MAX_LOOKBACK) > 0) ? (last - MAX_LOOKBACK) : 0;   // don't go all the way back

    var stop = Math.abs(POSNS[last].top_ys);
    var sbot = Math.abs(POSNS[last].bot_ys);
    var top_prob = POSNS[last].top_prob;
    var bot_prob = POSNS[last].bot_prob;
    if ((top_prob < MIN_POSN_SCORE) || (bot_prob < MIN_POSN_SCORE)) return [ null, null, null ];

    var dirtop = 0, dirbot = 0;     // direction
    var maxdtop = 0, maxdbot = 0;     // max delta
    var odirtop = null, odirbot = null, oetop = null, oebot = null;
    var del_top, del_bot;
    //for (var s = (last - 1); s >= 0; s--) {
    //console.log("posn.350:   * * * * * * START BODY_DY   hidx=",hidx, "  stop=",stop, " sbot=",sbot, " start=", start, " end=",end, "  * * * * *");  //, " dtop=",dtop, " dbot=",dbot);
    //console.log("posn.375:   * * * * * * START BODY_DY,  hidx,  top_y, bot_y, top_ys, bot_ys, del_top, del_bot, maxtop, maxbot, s");
    for (var s = start; s >= end; s--) {    // look at most recent
        var posn = POSNS[s];
        var fullbody = checkFullBody(posn);

        var etop = Math.abs(posn.top_ys);   // y should always be positive
        var ebot = Math.abs(posn.bot_ys);
        del_top = Math.abs(stop - etop);
        del_bot = Math.abs(sbot - ebot);
        dirtop = ((stop - etop) >= 0) ? 1 : -1;
        dirbot = ((sbot - ebot) >= 0) ? 1 : -1;

        //console.log("posn.337:      = = =  dirtop=",dirtop, " odirtop=",odirtop, " dirbot=",dirbot," odirbot=",odirbot, " etop=",etop, " ebot=",ebot );
        if (odirtop && ((dirtop !== odirtop) || (dirbot !== odirbot))) {
            break;
        }


        if ((dirtop === odirtop) && (dirbot === odirbot)) {
            if ((del_bot > maxdbot))  {
                maxdtop = del_top;
                maxdbot = del_bot;
                first = s;
            }
        }

        if ((hidx % 20) === 0) {
            if ((del_bot > 0) && ((oetop !== etop) || (oebot !== ebot))) {       // filter out dups
                //console.log("posn.404, ",(hidx + s), ", ", posn.top_y, ", ",posn.bot_y, ", ", posn.top_ys, ", ", posn.bot_ys, ", ",del_top, ", ",del_bot,", ",maxtop, ", ",maxbot,", ",s);
            }
        } 

        odirtop = dirtop;       // last direction
        odirbot = dirbot;
        oetop = etop;       // last posn
        oebot = ebot;
    }

    maxdtop = del_top;
    maxdbot = del_bot;
    if ((maxdtop > 0) && (maxdbot > 0)) {
        // must be big enough delta to filter out jitters
        //
        //console.log("posn.349:   _______  hidx=",hidx, "  maxdtop=",maxdtop, " maxdbot=",maxdbot, " first=", first, " last=",last, " samples=", (last - first));  //, " dtop=",dtop, " dbot=",dbot);
    }
    return [ maxdtop, maxdbot, (last - first) ];
}




// look up table to convert a line slope into degrees
//
export function calcDegree(stats, xx1, xx0, yy1, yy0) {
	var dx, dy, x0, y0, x1, y1, x2, y2;
	var degree;
	var yyy0 = birdseyeY(null, yy0);
	var yyy1 = birdseyeY(null, yy1);

	dx = xx1 - xx0;
	dy = yyy1 - yyy0;
	x0 = Math.abs(dx);
	y0 = Math.abs(dy);

	if((x0 < 3) && (y0 < 5)) {
		return -1;		// not enough movement to tell
	}
	x1 = (x0 >= y0) ? (dx/x0) : (dx/y0);
	y1 = (y0 >= x0) ? (dy/y0) : (dy/x0);

	x2 = Math.floor((x1 + 1) * 10) * 10;
	y2 = Math.floor((y1 + 1) * 10) * 10;
	//console.log("43: DEGREE=",DEGREE);
	//console.log("44: convert x=",dx, " y=",dy, " x1=",x1.toFixed(2), " y1=",y1.toFixed(2), " x2=",x2, " y2=",y2," dgree=",DEGREE[x2][y2])

	//degree = -(DEGREE[x2][y2] - 360);
	if(DEGREE[x2] !== undefined) {
		degree = DEGREE[x2][y2];
	} else {
		//console.log("degree.300: BAD DEGREE   x2=", x2, " y2=",y2, " yyy0=",Math.floor(yyy0), " yyy1=",Math.floor(yyy1));
		degree = -1;
	}
	return degree;
}


// need to transform Y with factor to get accurate distance
// returns:  speed, distance, direction 
export function calcMoveVector(stats, x1, x0, y1, y0, t1, t0) {
	//var px_ratio = stats.pixel_ratio
	//var px_ratio = INFO.pixel_ratio;       // always use this, slow and steady
	var px_ratio = STATS.pixel_ratio;       // always use this, slow and steady

	var distance = calcDistance(px_ratio, x1, x0, y1, y0);	// pixels
	var direction = calcDirection(x1, x0, y1, y0);	// custom vectors
	var degree = calcDegree(null, x1, x0, y1, y0);
	//var [ft_speed, m_speed]= calcSpeed(px_ratio, distance, t1 - t0);
	//var speed = m_speed;
	var speed = calcSpeed(px_ratio, distance, t1 - t0);

	//console.log("calc.74:     . . . dist=",distance, " dt0=",(t1-t0), " px_ratio=",parseInt(px_ratio), " speed=",speed.toFixed(2), " degree=", degree);
	return [ speed, distance, direction, degree ]
}


// calc simple pixel distance
export function calcPixelDistance(x1, x0, y1, y0) {
	var dx = x0 - x1;
	var dy = y0 - y1;
	//console.log("udist.330:  .  .  .  .  DIST:  x0=",x0, " y0=",y0, " x1=",x1, " y1=",y1);
	return(Math.floor(Math.sqrt( dx*dx + dy*dy )));
}



// calc distance in feet, need to account for non-linear Y factor (expand out)
//    - roughly 1 Y pixel up means 0.5% in femur ratio, both edges are non-linear
//    - femur ratio need to determined via histogram
export function calcDistance(px_ratio, x1, x0, y1, y0) {

	var dx = x0 - x1;
	var dy = y0 - y1;
	var d = Math.floor(Math.sqrt( dx*dx + dy*dy ))

    return d;       // no y adjustments


    /* OLD STATS CALC
	var m, yr0;
	if (stats && (stats.ratio_femur_y > 0) && (stats.ref_y > 0)) {
		m = (stats.ratio_femur_y / 100);
		yr0 = stats.ref_y;
	} else {
		m = 0.3;		// arbitrary for non-real world calcs
		yr0 = 400;
	} 

	if ((INFO.ratio_femur_y > 0) && (INFO.ref_y > 0)) {
		m = (INFO.ratio_femur_y);
		yr0 = INFO.ref_y;
	} else {
		m = 0.3;		// arbitrary for non-real world calcs
		yr0 = 400;
	}

	var yr0m = yr0 / m;
	var y0m = y0 / m;
	var y1m = y1 / m;
	var ady0 = (y0 > yr0) ? (y0m - yr0m) : (yr0m - y0m);
	var ady1 = (y1 > yr0) ? (y1m - yr0m) : (yr0m - y1m);
	var yy0 = y0 + ady0;
	var yy1 = y1 + ady1;

	var dx = x0 - x1;
	//var dy = y0 - y1 + ady0 + ady1;
	var dy = yy0 - yy1;
	var d = Math.floor(Math.sqrt( dx*dx + dy*dy ))

	//console.log("udist.330:  adjust Y  y0=",y0, " y1=",y1, " m=",m.toFixed(1), " yr0=", yr0, " ady0=", Math.floor(ady0), " ady1=", Math.floor(ady1));
	//console.log("udist.332:     yr0=",yr0, "       y0=",y0, "=>  new.y0=",Math.floor(yy0), "   y1=",y1, "=>  new.y1=",Math.floor(yy1), "   d=",d);
	return d;
    */
}


// return femur per second
export function calcSpeed(px_ratio, dist_px, time_msec) {
	//var px_ratio = (stats.pixel_ratio) ? stats.pixel_ratio : STATS.pixel_ratio;
	//var px_ratio = STATS.pixel_ratio;       // always use this, slow and steady

	//var distm = (dist_px / (px_ratio * 100)).toFixed(3);		// convert to meter
	var distf = dist_px / INFO.ref_femur;
	var speedf = parseFloat(distf / time_msec * 1000);		// meter per second
	return speedf;

    // OLD: meter code
	var distm = (dist_px / (px_ratio)).toFixed(3);		// convert to meter
	var speedm = (distm / time_msec * 1000);		// meter per second
	var m_speed = parseFloat(speedm);		// conver to ft per sec
	var ft_speed = parseFloat(speedm * 3.28);		// conver to ft per sec
	//console.log("speed.590:       speed=",speed, " px_ratio=",px_ratio," distm=",distm, " speedm=",speedm, "  time_msec=",time_msec);
	return [ ft_speed, m_speed ];
}



// convert Y pixel on screen (compressed) into estimated actual "birdseye" pixel
//     - roughly every Y pixel down increase ratio by 0.5% (in linear region)
//     - returns expanded birdseye Y pixel
// 	   - ??? use Dy = (L / m) - (h / m).....L is reference Femur, h is target femur
//
//		- TRY: First find Femur at Y.new
//		- DF = F.new - F.ref
//		- DD = DF / m
//		- D.new = Y.new + DD
//
export function birdseyeY(stats, y0) {
	return(y0);			// not working, return old one

	/*
	var m = (stats.ratio_femur_y / 100);
	m = 0.8;		// KLUDGE: SEE WHAT HAPPENS
	var yr = stats.ref_y;
	var fmr = (stats.ref_femur == null) ? 0 : stats.ref_femur;
	var df = (y0 - yr);
	var dd = df / m;
	var yy0 = y0 - dd;

	/*
	var yrm = yr / m;
	var y0m = y0 / m;
	var ady0 = (y0 > yr) ? (y0m - yrm) : (yrm - y0m);
	var yy0 = y0 + ady0;
	console.log("bird.374:  y0-", y0, " yr=", yr, " m=", m.toFixed(3), " ady0=", ady0, " yy0=", yy0);

	if((m > 0) && (y0 > 0)) {
		//var yy0 = y0 / m;
		console.log("bird.385:  yy0-", Math.floor(yy0), " y0=", Math.floor(y0), " m=", m.toFixed(3), " dd=",dd);
		return(yy0);		// actual birds eye Y
	} else {
		return(y0);			// can't convert, return old one
	}
	*/
}


// return femur
export function calcPixel2Femur(dist_px) {
	var femur = dist_px / INFO.ref_femur;
	return(femur);
}

// return pixel
export function calcFemur2Pixel(femur) {
	var pixel = parseFloat(femur) * INFO.ref_femur;
	return(pixel);
}


// return meter per second
export function calcPixel2Meter(px_ratio, dist_px) {
	var meter = dist_px / (px_ratio);		// convert to meter
	return(meter);
}


// return feet per second
export function calcPixel2Feet(px_ratio, dist_px) {
	var meter = (dist_px / (px_ratio));		// convert to meter
	var feet = (meter * 3.28);		// conver to ft per sec
	return(feet);
}


// return pixel per second
export function calcMeter2Pixel(px_ratio, dist_m) {
    var pixel = parseInt(parseFloat(dist_m) * (px_ratio));		// convert to meter
	return(pixel);
}


// return pixels in X direction
export function calcFeet2Pixel(px_ratio, dist_ft) {
	var pixel = Math.floor((dist_ft * px_ratio) / 3.28);		// convert to meter
	//console.log("pix.104:  ratio=", px_ratio, " ft=", dist_ft, "  px=",pixel);
	return(pixel);
}



// **** MAY BE OBSOLETED BY calcBallStats() USING STATS.PIXEL_RATIO
//
// returns pixel per cm ratio
//   - use femur ratio, most consistent, need to know adjust or youth tho
//   - need to account for Y, keep histogram to determine Y-fudge ratio
//
export function calcPixelRatio() {
	var f0 = HISTORY[HISTORY.length - 1];
	// try to guess a base ratio so we can calculate speed
	// apply heuristics so it stays in reasonable range
	// recalculated and search until we get a higher confidence number
	var ratio = (f0.ball.valid === true) ? f0.ball.bb_x / 22 : 
				(f0.pose.valid === true) ? f0.pose.hip / 30 : 4; 		// pixel per cm, hard code to 4
	return ratio
}


// returns a scaling factor, bigger the Y (closer), bigger it is
// bottom: 1.4,  mid: 0.5
export function calcYScale(y0, width, height) {
	var sratio = width / height;
	var scale = 0;
	const sbig1 = 1.20;      // 1.3
	const sbig2 = 1.12;       // 1.2
	const ssmall1 = 0.7;	// horizontal aspect ratio
	const ssmall2 = 0.5;	// vertical aspect ratio
	const sdelta1 = sbig1 - ssmall1;
	const sdelta2 = sbig2 - ssmall2;
	const top_zone = 0.6;		// top half of screen  // 0.5
	const bot_zone = 0.7;       // 0.8
	var ratio1 = ((bot_zone * height) - y0)/((bot_zone - top_zone)*height);
	var ratio = (y0 / height);

	if (ratio > bot_zone) {
		scale = (sratio > 1) ? sbig1 : sbig2;		// cap at big
	} else  {
		if (ratio < top_zone) {
			scale = (sratio > 1) ? ssmall1 : ssmall2;		// cap at small
		} else {
			scale = (sratio > 1) ? (sbig1 - ((ratio1) * sdelta1)) : (sbig2 - ((ratio1) * sdelta2));
		}
	}
	//console.log("yscale.455: y0=",y0, " height=",height, " scale=",Math.floor(scale), " ratio=",ratio, "  ratio1=", ratio1," sratio=",sratio.toFixed(2));
	return scale;
}


export function timeDelta(msec) {
	var delta, now;
	if(!msec) {
	    msec = performance.now();
		//delta = ((msec - last_timestamp)/1000).toFixed(3);
		delta = parseInt(msec - last_timestamp);
		last_timestamp = msec;
	} else {
	    now = performance.now();
		//delta = ((now - msec)/1000).toFixed(3);
		delta = parseInt(now - msec);
	}
	return(delta)
}


// OBSOLETE: REPLACED BY DEGREE CALC
// 1,2,4   8,16,32  ==> 36 v 9,  20 v 17, 12 v 33, 10 v 34
// DIRECTION: 36=(+, +), 20=(+, 0), 12=(+, -), 10=(0, -), 
//			   9=(-, -), 17=(-, 0), 33=(-, +), 34=(0, +)
export const DIR={36: "UR", 20: "R", 12: "DR", 10: "D", 9: "DL", 17: "L", 33: "UL", 34: "U"}
export function calcDirection(x1, x0, y1, y0) {
	var dx = x0 - x1;
	var dy = y0 - y1;
	var xx, yy;

	if(dx < 1) {
		xx = 1;
	} else if (dx > 1) {
		xx = 4;
	} else {
		xx = 2;		// consider less than on pixel delta as zero
	}
	if(dy < 1) {
		yy = 8;
	} else if (dy > 1) {
		yy = 32;
	} else {
		yy = 16;
	}
	return xx + yy;		// special direction number for easy compare
}



// OBSOLETE: REPLACED BY DEGREE CALC
// filter out jitters and determin if there is a true direction chg
export function determineDirectionChange(dir, odir) {
	/*
	var hidx = HISTORY.length - 1;
	var f0 = HISTORY[hidx];
	for(var i = hidx; i >= 0; i--) {
	}
	var f1_body_dir = f1.action.body_dir;
	*/

	//console.log("575:  body_dir=", f0_body_dir, "   f1_body_dir=", f1.action.body_dir);
	var flip = false;
	// 1,2,4   8,16,32  ==> 36 v 9,  20 v 17, 12 v 33, 10 v 34
	switch(dir) {
		case 36:
			if (odir === 9) flip = true;
			break;
		case 20:
			if (odir === 17) flip = true;
			break;
		case 12:
			if (odir === 33) flip = true;
			break;
		case 10:
			if (odir === 34) flip = true;
			break;
		case 9:
			if (odir === 36) flip = true;
			break;
		case 17:
			if (odir === 20) flip = true;
			break;
		case 33:
			if (odir === 12) flip = true;
			break;
		case 34:
			if (odir === 10) flip = true;
			break;
		default:
			break;
	}
	return flip;
}


////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


// Load client device info to support variation
//
export function loadClientInfo() {

        // record device and browser state to determine pwa
        //
        INFO.user_agent = Util.getUserAgent();
        INFO.axos_version = parseInt(AXOS_VERSION);   // this is when client was built
        console.log("index.80: ***** CURRENT AXOS_VERSION: ",INFO.axos_version);
        console.log("index.81: ***** BROWSER_AGENT: ",INFO.user_agent);
        //var pwa = (('standalone' in window.navigator) && (window.navigator.standalone)) ? "pwa" : "browse";
        var [type, make, os, model, spd] = Util.getDeviceType();
        var device = {type: type,
                       make: make,
                       os: os,
                       model: model,
                       speed: spd }
        var [browser, browser_ver, engine, engine_ver] = Util.getBrowserType();
        var browse = { browser: browser,
                       browser_ver: browser_ver,
                       engine: browser,
                       engine_ver: engine_ver, }
 
        INFO.device_str = type+":"+make+":"+model+":"+spd;
        INFO.browser_str = browser+":"+browser_ver+":"+engine+":"+engine_ver;
        INFO.device = {...device};
        INFO.browser = {...browse};
        console.log("index.309: ***** DEVICE_INFO: type=",type, "  make=",make, " os=", os, " model=",model, " speed=", spd);
        console.log("index.311: ***** BROWSER_INFO:  browser=",browser, " ver=", browser_ver, " engine=",engine, " ver=", engine_ver);
}




var Status_Index = 0;
var Last_Msg_Time = 0;
const LOADING_MSG = ["Loading Player AI Model",
						"Importing Neural Weights",
						"none",
						"Initializing Input Stage",
						"Checking Feedback Stage",
						"none",
						"Normalizing Network Neurons",
						"Verifying Control Loop",
						"none",
						"Initializing Output Stage",
						"Preparing Webcam Config",
						"none",
						"Normalizing Backstage Weights",
						"Finalizing AI Model",
						"none"
					]
const GOOF_MSG = ["Waiting for Amazon Delivery",
					"Checking Netflix",
					"Playing Minecraft",
					"Mowing the Lawn",
					"Taking Out Trash",
					"Snapchat My Homies",
					"Drinking Snapples",
					"Petting My Cat",
					"Checking the Weather",
					"Crushing Roblox",
					"Cleaning Up My Room",
					"Finishing Homework",
					"Feeding the Dog",
					"Texting My Buddy",
					"Doing My Nails",
				]
// display changing loading messages in case of long wait
export function showLoadingMessage(percent) {
	var status_text;
	const goof_len = GOOF_MSG.length;
	var status = document.getElementById('status_text');
	if(status == null) {
		return;
	}

	var t1 = Math.floor(performance.now());
	var delta = Math.floor(t1 - Last_Msg_Time);
	if(delta < 700){
		//console.log("msg.594: t1=",t1, " delta=", delta);
		return;		// too soon
	}
	Last_Msg_Time = t1;

	if((percent !== undefined)){
		//console.log("msg.590: Loading percent=", Math.floor(percent*100));
	}

	if ((Status_Index % 3) === 2) {
		var goof_idx = Math.floor((Math.random() * goof_len) + Status_Index) % goof_len;
		status_text = GOOF_MSG[goof_idx];
	} else {
		status_text = LOADING_MSG[Status_Index];
	}

	status.textContent = status_text;
	Status_Index = Status_Index + 1;
	if(Status_Index === LOADING_MSG.length) {
		Status_Index = 0;
	}
	//setTimeout(showLoadingMessage, 500);   // every second
}


// returns a Image from file path
export async function loadImage(path) {

        const nimage = new Image();
        var promise = new Promise((resolve, reject) => {
            nimage.src = path;
            nimage.crossOrigin = '';
            //console.log("image.629: READING DEFENDER IMAGE...  ", nimage.src)
            nimage.onload = () => {
                resolve(nimage);
                //console.log("image.632: Load SUCCESS  ", nimage.src)
                return nimage;
            };
        });
    return promise;
}


// format the timestamp to minute.sec.msec
export function formatTimestamp(raw_msec, mark) {
	var raw_sec = Math.floor(raw_msec / 1000);
	var raw_min = Math.floor(raw_sec / 60);
	var msec = Math.floor(raw_msec % 1000).toString().padStart(3, "0");
	var sec = (raw_sec % 60).toString().padStart(2, "0");
	var min = (raw_min % 60).toString().padStart(3, "0");

	var out = (min+"."+sec+"."+msec);
	//console.log("util.706:                            timestamp=",out, "   mark=",mark);
	return out;
}


// examine canvas value and score the image brightness
// use this to adjust for outdoor daylight conditions (need high contrast)
//
export function imageDarkness(imageSrc,callback) {
	var fuzzy = 0.1;
	var img = document.createElement("img");
	img.src = imageSrc;
	img.style.display = "none";
	document.body.appendChild(img);

	img.onload = function() {
		// create canvas
		var canvas = document.createElement("canvas");
		canvas.width = this.width;
		canvas.height = this.height;

		var ctx = canvas.getContext("2d");
		ctx.drawImage(this,0,0);

		var imageData = ctx.getImageData(0,0,canvas.width,canvas.height);
		var data = imageData.data;
		var r,g,b, max_rgb;
		var light = 0, dark = 0;

		for(var x = 0, len = data.length; x < len; x+=4) {
			r = data[x];
			g = data[x+1];
			b = data[x+2];

			max_rgb = Math.max(Math.max(r, g), b);
			if (max_rgb < 128)
				dark++;
			else
				light++;
		}

		var dl_diff = ((light - dark) / (this.width*this.height));
		if (dl_diff + fuzzy < 0)
			callback(true); /* Dark. */
		else
			callback(false);  /* Not dark. */
	}
}

/// debug code
//  src: https://stackoverflow.com/questions/13762864/image-brightness-detection-in-client-side-script
function testImageDarkness () {
	var imgs = document.body.getElementsByTagName('img');
	for(var x = 0; x < imgs.length; x++) {
		imgs[x].onclick = 
				function() {
					imageDarkness(this.src, 
					function(darkornot) {
						document.getElementsByTagName('pre')[0].innerHTML = "Dark ? " + darkornot;
					});            
				}
	}
} 



export function setScreenOrientation(wd, ht, from) {
	var aspect = wd / ht;
    var shape, vertical_mode;

	vertical_mode = false;
	if (aspect >= CONSTS.SCREEN_SUPER_WIDE_RATIO) {
		//shape = "super_wide";
		shape = "horizontal";
	} else if (aspect >= CONSTS.SCREEN_HORIZONTAL_RATIO) {
		shape = "horizontal";
	} else {
		vertical_mode = true;
		if (aspect <= CONSTS.SCREEN_SUPER_NARROW_RATIO) {
			//shape = "super_narrow";
			shape = "vertical";
		} else {
			shape = "vertical";
		}
	}
    //console.log("orient.1742:    ..... ORIENTATION CHANGE  from", from, "  vertical_mode=",vertical_mode, "  shape=",shape, " wd=",wd, "  ht=",ht);
    return [ vertical_mode, shape ];
}



// lock to horizontal orientation - DOES NOT WORK
//
// src: https://usefulangle.com/post/105/javascript-change-screen-orientation
// ref.IOS: http://www.evotech.net/blog/2007/07/web-development-for-the-iphone/
//
export function lockScreenHorizontal() {
    return;     // messing up on IOS

    console.log('horiz.765:  ........LOCKING Horizontal Screen....');
    // we still need prefixed methods for Chrome & Safari
    if(document.querySelector("#root").requestFullscreen) {
        console.log("horiz.768:  ........REQUEST FULL SCREEN");
        document.querySelector("#root").requestFullscreen();
    } else if(document.querySelector("#root").webkitRequestFullScreen) {
        console.log("horiz.768:  ........REQUEST IOS FULL SCREEN");
        document.querySelector("#root").webkitRequestFullScreen();
    }

    console.log('horiz.775:  ORIENTATION ', window.screen.orientation);
    document.body.setAttribute("orient", "landscape");      // for IOS
    window.screen.orientation.lock("landscape")
        .then(function() {
            console.log('horiz.773:  Horizontal Screen Locked');
        })
        .catch(function(error) {
            console.log('horiz.776:  ERROR: Horizontal Screen Locked ',error);
        });


}


export function unlockScreenOrientation() {
    return;     // messing up on IOS
    console.log('unlock.784:  ..........Screen Orientation UNLOCKED');
    window.screen.orientation.unlock();
}



// manually adjust the video canvas for preserve aspect ratio, the "height: auto" does not work
//
var vconsole_log = (false || (INFO.show_vconsole == true)) ? console_log : () => {};		// TRUE will show console.log
export function adjustDisplayDiv(from) {
	var output = null, video = null, has_video = true;
	var shape = "", vertical_mode, ht, wd, oaspect, oht, owd, vht, vwd, dht, dwd;
	var swidth_val = 0, swidth = "", sheight_val = 0, sheight = "", aswidth = 0, asheight = 0;
	var goback_ht = CONSTS.GOBACK_BAR_HEIGHT;
	//var display = document.querySelector('.display_container');
	//var results = document.getElementById('results_container');
	var root = document.getElementById('main_root');
	var display = document.getElementById('display_container');

    var practice_mode = (INFO.practice_mode || INFO.perf_mode) ? true : false;      // merge to use same code

    if(display === null) {
        vconsole_log("adjust.832: !!!!!!!!!!! DIV ADJUST EXIT - no display");
        return [0, 0];
    }

	//aspect = window.innerHeight / window.innerWidth;
	ht = Math.round(display.offsetHeight);
	wd = Math.round(display.offsetWidth);
	var aspect = 0.0;

    if(display === undefined){
        aspect = 1.77;
    } else {
        aspect = Math.round(wd / ht * 1000) / 1000;     // display spaect ratio
        [vertical_mode, shape ] = setScreenOrientation(wd, ht, "ADJUST.846");
    }


	vconsole_log("adjust.791:   # # # # # # # # # # #  DIV ADJUST ",from,"   tuto=",INFO.tutorial_mode, "   drill=",practice_mode, 
                 " analy=",INFO.analyze_mode,"  perf=",INFO.perf_mode, " mock=",INFO.mock_mode, " ht=",ht, " wd=",wd, " aspect=",aspect);
	if (INFO.tutorial_mode === true) {
		output = document.getElementById('tut_output');
		video = document.getElementById('tut_video_container');
        dwd = (display === null) ? 0 : Math.round(display.offsetWidth);     // arbitray tutorial container
        dht = (display === null) ? 0 : Math.round(display.offsetHeight);    // arbitray tutorial container
        vwd = (video === null) ? 0 : Math.round(video.offsetWidth);        // defined video container
        vht = (video === null) ? 0 : Math.round(video.offsetHeight);        // defined video container
		owd = (output === null) ? 640 : output.width;		// video has a delay, so value may not be set
		oht = (output === null) ? 480 : output.height;

	//} else if ((INFO.game_mode === true) || (INFO.analyze_mode === true)) {
	} else if (INFO.game_mode === true) {
		// artificial aspect ratio - pick up what is not in sidebar
        has_video = false;	// no video screen
        output = document.getElementById('drill_output');
        video = document.getElementById('drill_video_container');

		if (INFO.vertical_mode === true) {
			owd =  wd;
			oht =  ht - CONSTS.SIDEBAR_HEIGHT;		// reserve some space
		} else {
			owd =  wd - INFO.sidebar_width;
			oht =  ht;
		}
        vconsole_log("adjust.886:     . . . . .  GAME MODE:  output=",output, " video=",video, " owd=",owd," oht=",oht);

	} else if ((INFO.mock_mode === true) || (INFO.footage_mode === true)) {
		if (INFO.mock_mode === true) {
			has_video = true;	// has video screen
			//output = document.getElementById('drill_output');  // bad
			output = document.getElementById('drill_output0');      // good
			video = document.getElementById('drill_video_container');
		} else {
			has_video = true;	// has video screen
			output = document.getElementById('drill_output0');
			video = document.getElementById('drill_video_container');
			//output = document.getElementById('review_output');
			//video = document.getElementById('review_video_container');
            vconsole_log("adjust.914:     . . . . .  REVIEW MODE: ??? ");
		}

		if (INFO.vertical_mode === true) {
			owd =  wd;
			oht =  ht - CONSTS.SIDEBAR_HEIGHT;		// reserve some space
		} else {
			//owd =  Math.floor(wd - INFO.sidebar_width);     // mock round down
			owd =  wd - INFO.sidebar_width;
			oht =  ht;
		}
        vconsole_log("adjust.886:     . . . . .  MOCK MODE:   footage_mode=",INFO.footage_mode,"  output=",output, " video=",video, " owd=",owd," oht=",oht);

	} else if (practice_mode === true) {
		output = document.getElementById('drill_output');   // <video>
		video = document.getElementById('drill_video_container');		// get true video play file ratio
		owd = (!output) ? CONSTS.WEBCAM_BASE_WIDTH_FN()  : Math.floor(output.width);		// video has a delay, so value may not be set
		oht = (!output) ? CONSTS.WEBCAM_BASE_HEIGHT  : Math.floor(output.height);
        vconsole_log("adjust.932:     . . . . .  PRACTICE MODE:   owd=",owd, " oht=",oht);

    } else if (INFO.perf_mode === true) {
		output = document.getElementById('output');     // canvas
		video = document.getElementById('video_container');
		owd = (INFO.webcam_owidth === null) ?  CONSTS.WEBCAM_BASE_WIDTH_FN() : Math.floor(INFO.webcam_owidth);
		oht = (INFO.webcam_oheight === null) ?  CONSTS.WEBCAM_BASE_HEIGHT : Math.floor(INFO.webcam_oheight);
        vconsole_log("adjust.939:     . . . . .  PERF MODE:   owd=",owd, " oht=",oht);

    } else if (INFO.analyze_mode === true) {
        /*
        has_video = true;	// has video screen
		//video = document.getElementById('video_container');
		//video = document.getElementById('video');
		//output = document.getElementById('output');
		//video = document.getElementById('drill_output');
        output = document.getElementById('drill_output');
        video = document.getElementById('vimeo_player_container');

		//owd = (output === null) ? 640 : Math.floor(output.width);		// video has a delay, so value may not be set
		//oht = (output === null) ? 480 : Math.floor(output.height);
        vconsole_log("adjust.949:     . . . . . ! ! ! !  ANALYZE.2 MODE:  ");
        */

        // NOTE: need to call adjust AFTER video is loaded!
        //
        has_video = true;	// has video screen
        output = document.getElementById('drill_output');           // <video>
        video = document.getElementById('vimeo_player_container');  // player

        if (!output || !output.width) {  // if no video player then webcam mode
            // webcam mode
            output = document.getElementById('output');     // AI canvas
            video = document.getElementById('video_container');
        }
        //output = document.getElementById('output');           // display
        //video = document.getElementById('vimeo_player_container');  // player
		owd = (!output) ? CONSTS.WEBCAM_BASE_WIDTH_FN()  : Math.floor(output.width);		// video has a delay, so value may not be set
		oht = (!output) ? CONSTS.WEBCAM_BASE_HEIGHT  : Math.floor(output.height);
        vconsole_log("adjust.891:     . . . . .  ANALYZE MODE:  owd=",owd, " oht=",oht," ", output, video);

    } else {
        console.log("adjust.832:      ******** ADJUST: NO ACTIVE MODE YET *********");
        return [0, 0];
    }

	oaspect = (!owd) ? 1.77 : Math.round(owd / oht * 1000) / 1000;
    var dratio = aspect;
	vconsole_log("adjust.792:         ..... ADJUST RAW   w.wd=",INFO.webcam_owidth, "  w.ht=",INFO.webcam_oheight," o.wd=",owd, "  o.ht=",oht, " d.wd=",wd, " d.ht=",ht);

	//if ((has_video === true) && ((output === null) || (video === null) || (display === null))) {
	if ((has_video === true) && (!output || !video || !display)) {
		vconsole_log("adjust.772:        ..... NO ADJUST   output=",(output != null), "   video=",(video != null), "  display=",(display != null), " owd=",owd, " oht=",oht);
		return [0, 0];         // not ready yet
	}


	// check output aspect ratio against video aspect ratio
    //    - aspect:  display aspect ratio
    //    - ospect: the video or webcam ratio
    //    - sheight: calc video height
    //    - ysheight: youtube adjusted height
	//
	if(aspect > oaspect) {
		//aswidth = "100vw";
		//sheight = Math.floor(((wd / owd) * oht) - goback_ht)+"px";
		aswidth = Math.round(wd);
		asheight = Math.round(((wd / owd) * oht) - goback_ht);
		vconsole_log("aspect.807:         ..... SRC ASPECT BIGGER : as.ht=",asheight, " as.wd=",aswidth, "  ht=",ht, " wd=", wd, "  aspect=", aspect, " oht=",oht, " owd=",owd, "  oaspect=",oaspect.toFixed(3)); 
	} else {
		// vertical mode - use max width
		//
		aswidth = Math.round(wd);	
		asheight = Math.round(((wd / owd) * oht));   // KLUDGE!
		vconsole_log("adjust.848:         ..... OUTPUT ASPECT BIGGER : as.ht=",asheight, " as.wd=",aswidth, "  ht=",ht, " wd=", wd, "  aspect=", aspect, " oht=",oht, " owd=",owd, "  oaspect=",oaspect.toFixed(3)); 
	}

	// KLUDGE: Special case big wide
	var xkludge = 1;		// account for rounding issues
	if(wd > 1400) {
		//xkludge = 20; 
	}

	vconsole_log("adjust.806:         ..... BASE: asht=",asheight, " aswd=",aswidth, "  ht=",ht, " wd=", wd, "  aspect=", aspect, " oht=",oht, " owd=",owd, "  oaspect=",oaspect.toFixed(3)); 
	if (INFO.tutorial_mode === true) {
		//if(aspect > oaspect) 
        var vaspect = (vwd == null) ? 2 : (vwd / vht);
		if (INFO.vertical_mode === false) {
			// horizontal
            swidth_val = Math.round(dwd);
            sheight_val = Math.round(swidth_val / oaspect);
            swidth = swidth_val + "px"
			sheight = sheight_val + "px";
            vconsole_log("adjust.889:         TUTORIAL HORIZONTAL:  vht=",vht, " vwd=",vwd,"  sht=",sheight, "  swd=",swidth,"  ht=",ht, " wd=", wd, "  aspect=", aspect.toFixed(3), " oht=",oht, " owd=",owd, "  oaspect=",oaspect.toFixed(3)); 
		} else {
			// vertical
            swidth_val = Math.round(dwd);
            sheight_val = Math.round(swidth_val / oaspect);
            swidth = swidth_val + "px"
			sheight = sheight_val + "px";
            vconsole_log("adjust.905:         TUTORIAL VERTICAL:  vht=",vht, " vwd=",vwd, " sht=",sheight, "  swd=",swidth,"  ht=",ht, " wd=", wd, "  aspect=", aspect.toFixed(3), " oht=",oht, " owd=",owd, "  oaspect=",oaspect.toFixed(3)); 
		}

    } else if (INFO.game_mode === true) {
		if (INFO.vertical_mode === false) {
			// horizontal
			//swidth_val = Math.floor(wd - INFO.sidebar_width);
			swidth_val = Math.round(wd - INFO.sidebar_width - xkludge);	// KLUDGE: WHY 20?
			sheight_val = Math.round(ht - goback_ht);
            swidth = swidth_val + "px"
			sheight = sheight_val + "px";
		} else {
			// vertical
			swidth_val = Math.round(wd);
			sheight_val = Math.round(ht - goback_ht - INFO.sidebar_height);
            swidth = swidth_val + "px"
			sheight = sheight_val + "px";
			//asheight = sheight_val;		// KLUDGE!
			vconsole_log("adjust.878:         GAME  VERTICAL : sht=",sheight, " ht=",ht, " goback_ht=",goback_ht," sidbar_ht=",INFO.sidebar_height);
		}
		vconsole_log("adjust.1158:         GAME: sht=",sheight,"  swd=",swidth, "  ht=",ht, " wd=", wd, "  aspect=", aspect.toFixed(3), " oht=",oht, " owd=",owd, "  oaspect=",oaspect.toFixed(3), " goback_ht=",goback_ht); 

    } else if (INFO.mock_mode === true) {
		if (INFO.vertical_mode === false) {
			// horizontal
			//swidth_val = Math.floor(wd - INFO.sidebar_width);
			swidth_val = Math.round(wd - INFO.sidebar_width - xkludge);	// KLUDGE: WHY 20?
			sheight_val = Math.round(ht - goback_ht);
            swidth = swidth_val + "px"
			sheight = sheight_val + "px";
		} else {
			// vertical
			swidth_val = Math.floor(wd);
			sheight_val = Math.floor(ht - goback_ht - INFO.sidebar_height);
            swidth = swidth_val + "px"
			sheight = sheight_val + "px";
			//asheight = sheight_val;		// KLUDGE!
			vconsole_log("adjust.878:         MOCK  VERTICAL : sht=",sheight, " ht=",ht, " goback_ht=",goback_ht," sidbar_ht=",INFO.sidebar_height);
		}
		vconsole_log("adjust.1177:         MOCK: sht=",sheight,"  swd=",swidth, "  ht=",ht, " wd=", wd, "  aspect=", aspect.toFixed(3), " oht=",oht, " owd=",owd, "  oaspect=",oaspect.toFixed(3), " goback_ht=",goback_ht); 

	} else if (practice_mode === true) {
		if (INFO.vertical_mode === false) {
			// practice: horizontal mode
			swidth_val = Math.round(wd - INFO.sidebar_width - xkludge);	// KLUDGE: WHY 20?
			sheight_val = Math.round(swidth_val / aspect);     // only video height (oaspect gave a gap)
			//sheight_val = Math.round(ht - goback_ht);   // covers all the space (not work for vimeo)

            swidth = swidth_val + "px"
			sheight = sheight_val + "px";

		} else {
			// practice: vertical, keep it small
			swidth_val = Math.round(wd);
			sheight_val = Math.round(swidth_val / oaspect);
            swidth = swidth_val + "px"
			sheight = sheight_val + "px";
			//sheight = Math.floor(ht - goback_ht - INFO.sidebar_height);
			//asheight = sheight;		// KLUDGE!
		}
	    vconsole_log("adjust.1198:         PRACTICE: sht=",sheight,"  swd=",swidth, "  ht=",ht, " wd=", wd, "  aspect=", aspect.toFixed(3), " oht=",oht, " owd=",owd, "  oaspect=",oaspect.toFixed(3)); 

    } else if (INFO.perf_mode === true) {
		// challenge mode
		if (INFO.vertical_mode === false) {
			// perf: horizontal
			swidth_val = Math.round(wd - INFO.sidebar_width - xkludge);	// KLUDGE: WHY 20?
			sheight_val = Math.round(ht - goback_ht);
            swidth = swidth_val + "px"
			sheight = sheight_val + "px";
		} else {
			// perf: vertical
			swidth_val = Math.round(wd);
			sheight_val = Math.round(swidth_val / oaspect);
            swidth = swidth_val + "px"
			sheight = sheight_val + "px";
		}
	    vconsole_log("adjust.1215:         CHALLENGE: sht=",sheight,"  swd=",swidth, "  ht=",ht, " wd=", wd, "  aspect=", aspect.toFixed(3), " oht=",oht, " owd=",owd, "  oaspect=",oaspect.toFixed(3)); 

    } else if (INFO.analyze_mode === true) {
		if (INFO.vertical_mode === false) {
			// analysis: horizontal mode
			swidth_val = Math.round(wd - INFO.sidebar_width - xkludge);	// KLUDGE: WHY 20?
			//sheight_val = Math.round(ht - goback_ht);
			//sheight_val = Math.round(swidth_val / oaspect);
            if (INFO.dev_webcam_mode === true) {
                sheight_val = Math.round(swidth_val / aspect);      // KLUDGE: NOT SURE WHY 
            } else {
                sheight_val = Math.round(swidth_val / oaspect);
            }
            swidth = swidth_val + "px"
			sheight = sheight_val + "px";
		} else {
			// analysis: vertical, keep it small
			swidth_val = Math.round(wd);
			//sheight_val = Math.round(swidth_val / oaspect);
			sheight_val = Math.round(swidth_val / aspect);
            swidth = swidth_val + "px"
			sheight = sheight_val + "px";
		}
	    vconsole_log("adjust.1104:         ANALYSIS: sht=",sheight,"  swd=",swidth, "  ht=",ht, " wd=", wd, " oaspect=",oaspect, "  aspect=", aspect, " oht=",oht, " owd=",owd);
    }


    // KLUDGE: DO NOT USE INFO.youtube_player!!!  NEED TO BE OBJECT-ORIENTED, PASS IN THE PLAYER
    // 
	//var youtube_kludge = (practice_mode === true) ? 0 : CONSTS.YOUTUBE_VERTICAL_KLDUGE 
    //var ysheight_val = (INFO.youtube_player === true) ? parseInt(sheight_val) + youtube_kludge : sheight_val;     // KLUDGE: HIDE YOUTUBE "play next"
	var youtube_kludge0 = (INFO.youtube_player === true) ? CONSTS.YOUTUBE_VERTICAL_KLDUGE : 0;     // KLUDGE: HIDE YOUTUBE "play next"
	var youtube_kludge = (INFO.perf_mode === true) ? 0 : youtube_kludge0;
    var ysheight_val = parseInt(sheight_val) + youtube_kludge;
    var ysheight = ysheight_val + "px";
	vconsole_log("adjust.1064:         . . . . .  ORIENTATION SHAPE=",shape, "  d.ow=",display.offsetWidth, " d.oh=", display.offsetHeight, "  aspect=", aspect.toFixed(3), " ytkludge=", youtube_kludge);

	switch (shape) {
		case "square":
                output.style.width = swidth;
                output.style.height = "50%";
                output.style.maxWidth = ""; 	// intentional blank
                video.style.width = swidth;
                video.style.height = "";		// intentional blank
                video.style.maxWidth = ""; 		// intentional blank
                //setOffsetHeight(output, display.offsetHeight);
                vconsole_log("adjust.259:          SQUARE      d.ow=",display.offsetWidth, " d.oh=", display.offsetHeight, 
                            " o.w=",output.style.width, " o.h=", output.style.height, 
                            " o.ow=",output.offsetWidth, " o.oh=", output.offsetHeight, 
                            //" r.ow=",results.offsetWidth, "  r.oh=",results.offsetHeight,
                            " root.ow=",root.offsetWidth, "  root.oh=",root.offsetHeight);
                break;
            case "vertical":
                output.style.width = "100%";    // was 100vw
                output.style.height = ysheight;
                output.style.maxWidth = ""; 		// intentional blank
                setOffsetHeight(output, ysheight_val);
                video.style.width = "100%";     // was 100vw
                video.style.height = "";		// intentional blank
                video.style.maxWidth = ""; 		// intentional blank
                //output.style.height = asheight+"px";
                vconsole_log("adjust.904:          VERTICAL      d.ow=",display.offsetWidth, " d.oh=", display.offsetHeight, 
                            " o.w=",output.style.width, " o.h=", output.style.height, 
                            " o.ow=",output.offsetWidth, " o.oh=", output.offsetHeight, 
                            //" r.ow=",results.offsetWidth, "  r.oh=",results.offsetHeight,
                            " root.ow=",root.offsetWidth, "  root.oh=",root.offsetHeight);
                break;
            case "super_narrow":
                output.style.width = "100%";
                output.style.height = ysheight;
                output.style.maxWidth = ""; 		// intentional blank
                setOffsetHeight(output, ysheight_val);
                video.style.width = "100%";
                video.style.height = "";		// intentional blank
                video.style.maxWidth = ""; 		// intentional blank
                //output.style.height = asheight+"px";
                vconsole_log("adjust.917:          SUPER-NARROW      d.ow=",display.offsetWidth, " d.oh=", display.offsetHeight, 
                            " o.w=",output.style.width, " o.h=", output.style.height, 
                            " o.ow=",output.offsetWidth, " o.oh=", output.offsetHeight, 
                            //" r.ow=",results.offsetWidth, "  r.oh=",results.offsetHeight,
                            " root.ow=",root.offsetWidth, "  root.oh=",root.offsetHeight);
                break;
            case "horizontal":
            case "super_wide":
                output.style.width = swidth;    // leave room for control
                output.style.height = "";		// no auto, cause youtube to squish
                output.style.maxWidth = "";		// intentional blank
                setOffsetHeight(output, ysheight_val);        // bad "auto"
            video.style.width = swidth;		// leave room for control
            video.style.height = "100%";
            video.style.maxWidth = swidth; 	
                //video.style.height = "";		// intentional blank

                //video.style.maxWidth = ""; 		// intentional blank
                //video.style.height = "auto";
                vconsole_log("adjust.934:          HORIZONTAL      d.ow=",display.offsetWidth, " d.oh=", display.offsetHeight, 
                            " o.w=",output.style.width, " o.h=", output.style.height, 
                            " o.ow=",output.offsetWidth, " o.oh=", output.offsetHeight, 
                            " o.mt=",output.style.marginTop, 
                            //" r.ow=",results.offsetWidth, "  r.oh=",results.offsetHeight,
                            " root.ow=",root.offsetWidth, "  root.oh=",root.offsetHeight);  //, output, video);
                break;
            /*case "super_wide":
                //output.style.width = "100%"; 		// auto makes youtube squick
                //output.style.height = "";		// no auto, cause youtube to squish
                //output.style.maxWidth = swidth; 
            output.style.width = swidth;    // leave room for control
            output.style.height = "";		// no auto, cause youtube to squish
            output.style.maxWidth = "";		// intentional blank
            //setOffsetHeight(output, ysheight_val);
                //video.style.width = swidth; 	// need to for youtube?
                //video.style.height = "100%";
                //video.style.maxWidth = swidth; 
            video.style.width = swidth;		// leave room for control
            video.style.height = "100%";
            video.style.maxWidth = swidth; 	
                vconsole_log("adjust.950:          SUPER-WIDE      d.ow=",display.offsetWidth, " d.oh=", display.offsetHeight, 
                            " o.w=",output.style.width, " o.h=", output.style.height, 
                            " o.ow=",output.offsetWidth, " o.oh=", output.offsetHeight, 
                            //" r.ow=",results.offsetWidth, "  r.oh=",results.offsetHeight,
                            " o.mt=",output.style.marginTop, 
                            " root.ow=",root.offsetWidth, "  root.oh=",root.offsetHeight);
                break;*/
            default:
                vconsole_log("adjust.1139:          UNKNOWN SHAPE      d.ow=",display.offsetWidth, " d.oh=", display.offsetHeight, 
                            " o.w=",output.style.width, " o.h=", output.style.height, 
                            " o.ow=",output.offsetWidth, " o.oh=", output.offsetHeight, 
                            //" r.ow=",results.offsetWidth, "  r.oh=",results.offsetHeight,
                            " o.mt=",output.style.marginTop, 
                            " root.ow=",root.offsetWidth, "  root.oh=",root.offsetHeight);
                break;
        }

        vconsole_log("adjust.1154:      = = = = = FINAL ADJUSTED   shape=",shape, "  swidth=",swidth, "  sheight=",sheight, "  ysheight=",ysheight);
		return [swidth, sheight];       // for youtube video sizing
    }


/// UTIL: sort array based on ascending .timestamp field (oldest first)
export function arrayTimestampDesSort(a, b) {
    var field = "timestamp"
    if (a[field] == b[field]) { return 0; }
    else { return (a[field] > b[field]) ? -1 : 1; }
}

/// UTIL: sort array based on descending .timestamp (latest first)
export function arrayTimestampAscSort(a, b) {
    var field = "timestamp"
    if (a[field] == b[field]) { return 0; }
    else { return (a[field] < b[field]) ? -1 : 1; }
}

export function arrayTimelineAscSort(a, b) {
    var field = "timeline"
    if (a[field] == b[field]) { return 0; }
    else { return (a[field] < b[field]) ? -1 : 1; }
}

/// UTIL: sort array based on name (latest first)
export function arrayNameAscSort(a, b) {
    var field = "name"
    if (a[field] == b[field]) { return 0; }
    else { return (a[field] < b[field]) ? -1 : 1; }
}


/// UTIL: sort array based on sequence
export function arrayKeyAscSort(a, b) {
    var field = "key"
    if (a[field] == b[field]) { return 0; }
    else { return (a[field] < b[field]) ? -1 : 1; }
}


/// UTIL: sort array based on sequence
export function arrayLengthDesSort(a, b) {
    var field = "length"
    if (a[field] == b[field]) { return 0; }
    else { return (a[field] > b[field]) ? -1 : 1; }
}

/// UTIL: sort array based on sequence
export function arrayTimeAscSort(a, b) {
    var field = "time"
    if (a[field] == b[field]) { return 0; }
    else { return (a[field] < b[field]) ? -1 : 1; }
}

/// UTIL: sort array based on sequence
export function arrayToknAscSort(a, b) {
    var field = "tokn"
    if (a[field] == b[field]) { return 0; }
    else { return (a[field] < b[field]) ? -1 : 1; }
}

/// UTIL: sort array based on sequence
export function arrayTargetAscSort(a, b) {
    var field = "target"
    if (a[field] == b[field]) { return 0; }
    else { return (a[field] < b[field]) ? -1 : 1; }
}

/// UTIL: sort array based on sequence
export function arrayTargetDesSort(a, b) {
    var field = "target"
    if (a[field] == b[field]) { return 0; }
    else { return (a[field] > b[field]) ? -1 : 1; }
}

/// UTIL: sort array based on sequence
export function arrayUidDesSort(a, b) {
    var field = "uid"
    if (a[field] == b[field]) { return 0; }
    else { return (a[field] > b[field]) ? -1 : 1; }
}


/// UTIL: sort array based on sequence
export function arraySeqAscSort(a, b) {
    var field = "seq"
    if (a[field] == b[field]) { return 0; }
    else { return (a[field] < b[field]) ? -1 : 1; }
}

/// UTIL: sort array based on sequence
export function arrayPerfDesSort(a, b) {
    var field = "perf"
    if (a[field] == b[field]) { return 0; }
    else { return (a[field] > b[field]) ? -1 : 1; }
}

/// UTIL: sort array based on sequence
export function arrayGroupIdDesSort(a, b) {
    var field = "group_id"
    if (a[field] == b[field]) { return 0; }
    else { return (a[field] > b[field]) ? -1 : 1; }
}

/// UTIL: sort array based on track
export function arrayTrackAscSort(a, b) {
    var field = "track"
    if (a[field] == b[field]) { return 0; }
    else { return (a[field] < b[field]) ? -1 : 1; }
}

/// UTIL: sort array based on track
export function arrayTargetHashAscSort(a, b) {
    var field = "target_hash"
    if (a[field] == b[field]) { return 0; }
    else { return (a[field] < b[field]) ? -1 : 1; }
}


/// UTIL: sort array based on track
export function arrayOwnerHashAscSort(a, b) {
    var field = "owner_hash"
    if (a[field] == b[field]) { return 0; }
    else { return (a[field] < b[field]) ? -1 : 1; }
}


/// UTIL: sort array based on sequence
export function arrayPointsDesSort(a, b) {
    var field = "points"
    if (a[field] == b[field]) { return 0; }
    else { return (a[field] > b[field]) ? -1 : 1; }
}

/// UTIL: sort array based on sequence
export function arraySourceTimestampDesSort(a, b) {
    var field = "source_timestamp"
    if (a[field] == b[field]) { return 0; }
    else { return (a[field] > b[field]) ? -1 : 1; }
}

/// UTIL: sort array based on sequence
export function arrayValueAscSort(a, b) {
    var field = "value"
    if (a[field] == b[field]) { return 0; }
    else { return (a[field] < b[field]) ? -1 : 1; }
}


/// UTIL: sort array based on sequence
export function arrayValueDesSort(a, b) {
    var field = "value"
    if (a[field] == b[field]) { return 0; }
    else { return (a[field] > b[field]) ? -1 : 1; }
}



// DEV: ALSO CHECK INDEX.JS: handleDismissWait()
export function processServiceWorkerReload() {
	if(INFO.service_worker !== null) {
		INFO.service_worker.postMessage('Handle RELOAD from menu.862');
	}
	console.log("SVC-RELOAD.860: APP RELOADING START  current=", AXOS_VERSION);
	navigator.serviceWorker.ready.then(reg => {

		reg.active.postMessage('skipWaiting');      // tell active not to wait
		if ((reg.waiting !== null) && (reg.waiting !== undefined)) {
			reg.waiting.postMessage('skipWaiting');      // tell waiting not to wait
		}

		reg.update()
		.then(() => {
			console.log("SVC-RELOAD.758: UPDATED, CLAIMING NEW VERSION!");
			reg.active.postMessage('claim');

			//window.location.reload();      // force reload
			//window.location.assign("http://axos.cc");   // change root to for svc worker to activate (work?)
			window.location.replace("https://refresh.axos.cc/redirect");   // change root to for svc worker to activate (work?)
		})
	});

	// in case there is no registered service worker to refresh, just refresh
	setTimeout(() => {
		window.location.replace("https://refresh.axos.cc/redirect");   // change root to for svc worker to activate (work?)
	}, 300);
}


// pretty print an object array in CSV format for XLS import
//
export function dumpObject(objects) {
	var keys = "", out = "";
    if ((objects === undefined) || (objects === null))  return null;

	console.log("########################  SPREADSHEET CSV ########################", objects)
	for (var key in objects[0]) {
		//console.log(`${key}: ${object[key]}`);
		console.log("         key=",key);
		keys = keys + key + ",";
	}
	console.log(keys);

	for (var i = 0; i < objects.length; i++) {
		var object = objects[i];
		out = "";
		for (const key in object) {
			var val = object[key];
			out = out + val + ",";
		}
		console.log(out);
	}
	console.log("##############^^^^^^^^^^  SPREADSHEET CSV ^^^^^^^^^^##############")
}


/* NOT WORKING: CAN'T PASS IN 3rd param FIELD!
/// UTIL: sort array based on name (latest first)
export function arrayFieldAscSort(a, b, field) {
	if (a[field] == b[field]) {
		return 0;
	}
	else {
		return (a[field] < b[field]) ? -1 : 1;
	}
}
*/


// set the current date for this hash, store in db and chg cache
//
function updateTutorialReadState(hash, version) {
    var db = INFO.db_tutorials;
    var tut = null;
    if ((db === undefined) || (db === null))  return null;
    
    for(var i = 0; i < db.length; i++) {
        console.log("update.tut.1221:      . . . tut_db ",i,":   db[i]=", db[i]);
        if (db[i].type == "tutorial") {
            tut = i;
        }
    }

    console.log("update.tut.1229:     hash=",hash, " version=",version, "  tut=", tut);
    if(tut !== null) {
        var uid = INFO.db_tutorials[tut].id;
        INFO.db_tutorials[tut][hash] = version+":"+Date.now();  // update in-memory cache
    } else {
        console.log("update.tut.1231:  ERROR: NO DB TUTORIAL STATE FOUND!!!");
    }

    console.log("update.tut.1792:   AFTER UPDATE   INFO.db_tut=", INFO.db_tutorials[tut]);

    // store into type=tutorial!!
    var body = {};
    body[hash] = version+":"+Date.now();

    // only store to db if not anon user and not admin pretending to be other user
    //
    if ((INFO.anon_mode === false) && (INFO.uid === INFO.login_uid)) {
        dbUpdateTutorialState(uid, body);
    }
}




// main switch for showing tutorial
//     - first check the db aux state
//     - if not set then display tutorial (if mandatory)
//     - once viewed, set today's date in the aux flag
//
export function getTutorial(module, op, mode) {
    var show = {}
    var tut = null;
    var db = INFO.db_tutorials;
    if ((db === undefined) || (db === null))  return null;

    for(var i = 0; i < db.length; i++) {
        console.log("update.tut.1221:     . . . ",i,":   key=",db[i].key, " type=", db[i].type, " title=",db[i].title);
        if ((db[i].type == "tutorial") || (db[i].type == "tut")) {
            console.log("update.tut.1221:         + + + ",i,":   FOUND TUTORIAL  tuts=", db[i]);
            tut = i;
        }
    }
    if(INFO.db_tutorials === null) {
        setTimeout(()=> {
            console.log("tut.1271: .......No Tut data yet, Wait 300ms  ",  Date.now());
            getTutorial(module, op);
        }, 300)
        return;
    }

    var dbinfo = INFO.db_contents;
    const hash = module+"+"+op;
    console.log("tut.1177:  ======================= PROCESS TUTORIAL  "+hash+ " ========================", INFO.db_tutorials.length, " module=",module, " op=",op, " show_tut=",INFO.show_tutorial, " tut=",tut, "db=",INFO.db_tutorials, " dbinfo=",dbinfo);
    if (!dbinfo === null) {
        console.log("tut.1226:  ERROR: EMPTY TUTORIAL CONTENT FROM DB!");
        return null;
    }

    var status = (mode === "manual") ? null : INFO.db_tutorials[tut][hash];
    if ((mode === "manual") || ((INFO.show_tutorial) && (INFO.db_tutorials[tut]))) {
        var infos = dbinfo.filter(info => { return (info.key == hash) });
        var info = infos[0];

        var has_read = (status) ? true : false;
        console.log("tut.1253:    . . . status=",status, "  hash=",hash, " has_read=",has_read, " info=", info, " dbinfo=", dbinfo);
        if ((info) && (has_read === false)) {
            show = {name: info.title,
                text: info.text,
                url: info.video,
                width:"640", height:"370"};
            // tell database this has been read
            updateTutorialReadState(hash, info.version);
            console.log("tut.1250:   . . . RETURN TUTORIAL=", show);
            return show;
        }
    }

    return null;
}


////////////////////////////////////////////////////////////////////////
//   PROCESS DATABASE ITEMS
//
export function processDrillItems(drills) {
    if ((drills === undefined) || (drills === null))  return [];

    var items = [];
    for(var i = 0; i < drills.length; i++) {
        var train = drills[i];
        if (train.special === true) continue;

        var item = {};
        item.id = i;
        item.key = train.key;
        item.drill_key = train.key;
        item.level = parseInt(train.level);
        item.seq = train.seq;
        item.name = train.name;
        item.hash = train.hash;
        item.section_hash = train.section_hash;
        item.width = train.width;
        item.height = train.height;
        item.goals = [train.goals];     // KLUDGE: Downstream & DB NEED to pass in an array

        INFO.video_id = train.key;      // for debug
        INFO.action = train.action;      // for analyze sidebar select
        item.url = makeVideoLink(train.drill_video, "process_drill.1426");
        item.video_hash = train.drill_video;
        item.type = train.type;
        item.subtype = train.subtype;
        item.tag = train.tag;           // KLUDGE: for "juke"
        item.fingers = train.fingers;
        item.sets = train.sets;
        item.reps = train.reps;
        item.motion_hash = train.motion_hash;
        item.param1 = train.param1;
        item.param2 = train.param2;
        item.tot_sets = train.tot_sets;
        item.cur_sets = train.cur_sets;
        item.min_sets = train.min_sets;
        item.param1 = train.param1;
        item.param2 = train.param2;
        items.push(item);
        //console.log("process_drill.1439:     .  .  .  .    DRILL  ", item.key, "  item=",item);
    }
    //INFO.drill_param1 = parseSliceParams(train.param1);
    //INFO.drill_param2 = parseSliceParams(train.param2);
    //console.log("process_drill.1547:     .  .  .  .  DRILL  param1=", INFO.drill_param1 , "  param2=",INFO.drill_param2);

    //dumpObject(ITEMS);      // DEBUG ONLY, dumps out array in CSV
    items.sort(arrayKeyAscSort);
    for(var i = items.length - 1; i > 1; i--) {
        var item0 = items[i - 1];
        var item1 = items[i];
        if (item1.key == item0.key) {
            items.splice(i, 1);     // remove duplicate
        }
    }
    items.sort(arraySeqAscSort);
    return items;
}

export function processStateItems(mode, states) {
    var out = [];
    if((states === null) || (states === undefined) || (states.lenght === 0)) return [];

    // return only the selected mode
    switch (mode) {
        case "tutorials":
            out = states.filter(data => { return (data.type == "tutorial")});
            console.log("state.1935:     # # # # # # PROCESSED TUTORIAL ITEMS  ", out);
            break;
        case "scores":
            out = states.filter(data => { return (data.subtype == "daily_score")});
            break;
        case "leaders":
            out = states.filter(data => { return (data.type == "leader")});
            break;
    }
    return out;
}


export function processLeaderItems(states) {
    return states;
}




// UTIL
// input user drill sequences, return drills available to player
//      - only show the earliestl unfinished seq from each track
//      - do not show finished drills 
//
export function processDrillsFromSequence(all_drills, today) {
    const MAX_TRACK = 10;       // KLDUGE:
    if ((today === undefined) || (all_drills === undefined)) return []; 

    console.log("seq_drill.416:  Processing  drills=",all_drills.length, "  seqs=",today.length, " today=",today,"  all_drills=",all_drills);
    var drills = [], old_drills = [], progs = [];
    // first gather the drills
    //
    for (var i = 0; i < today.length; i++) {
        var seq = today[i];
        var active = ((seq.state == 5) || (seq.state == "5")) ? false : true;
        //var drill_hash = seq.drill_hash;
        var drill_hash = seq.action_hash;
        var ndrills = all_drills.filter(drill => { return drill.hash == drill_hash });
        var ndrill = {...ndrills[0]};       // copy over
        if ((ndrill !== null) && (ndrill !== undefined) && (ndrill.drill_key !== undefined)) {

            ndrill.seq_hash = seq.hash;                  // need this for match later
            ndrill.state = seq.state;                    // state 5 is completed
            ndrill.seq = seq.seq;                        // use the seq + track from sequence record (not drill)
            ndrill.key = seq.key;                        // key to the program
            ndrill.track = seq.track;                    // total completed sets before moving on
            ndrill.tot_sets = seq.tot_sets;              // total completed sets before moving on
            ndrill.min_sets = seq.min_sets;
            ndrill.cur_sets = seq.cur_sets;
            ndrill.last_timestamp = seq.last_timestamp;  // use this to figure out if today_cnt is valid
            //ndrill.level = seq.level;                    // level for coloring
            if(Date.now() > seq.last_timestamp) {
                ndrill.today_cnt = 0;        // next day, need to reset
            } else {
                ndrill.today_cnt = seq.today_cnt;
            }

            //console.log("seq_drill.1505:        Adding  driill_hash=",drill_hash, " ndrill=",ndrill);
            console.log("seq_drill.432:        Adding ",drill_hash, " ndrill=",ndrill.hash, " type=",ndrill.type, " prog=",ndrill.key," trk=", ndrill.track, " today.cnt=",ndrill.today_cnt, " last.ts=", seq.last_timestamp);
            if ((active === true) || (seq.active === true)) {
                ndrill.section_hash = "sct:axos:new:1";      // KLUDGE: MEGA HARD CODE ACTIVE SECTION!!  Need to read from db
                drills.push(ndrill);
            } else {
                ndrill.section_hash = "sct:axos:old:1";      // KLUDGE: MEGA HARD CODE DONE SECTION!!  Need to read from db
                //ndrill.cur_sets = ndrill.tot_sets;
                old_drills.push(ndrill);
            }

            // gather unique prog keys
            if (progs.includes(seq.key) === false) {
                progs.push(seq.key);
            }
        } else {
            console.log("seq_drill.1642:          Skipping ",drill_hash, " ndrill=",ndrill, " type=",ndrill.type, " prog=",ndrill.key," trk=", ndrill.track, " today.cnt=",ndrill.today_cnt, " last.ts=", seq.last_timestamp);
        }
    }

    drills.sort(arraySeqAscSort);
    var odrills = [];
    // select one drill from each track + program
    for (var i = 0; i < progs.length; i++ ) {
        var prog = progs[i];
        for (var track = 0; track < MAX_TRACK; track++) {
            var odrill = drills.filter(drill => { return ((drill.track == track) && (drill.key == prog)) });
            if(odrill.length > 0) {
                console.log("seq_drill.468:     prog=",prog,"  track=",track, "  odrill=",odrill);
                odrills.push(odrill[0]);
            }
        }
    }

    var fdrills = odrills.concat(old_drills);
    console.log("seq_drill.1612:    * * * * * * * FINAL  odrills=",fdrills, "  old_drills=",old_drills);
    return fdrills
}

// special code sequence to do special things in the app
//
export function processEasterEggAction() {
    var keys = [...INFO.easter_egg];
    if ((keys == undefined) || (keys === null) || (keys.length < 3)) {
        console.log("easter.1300:   NOT ENOUGH KEYS  ",keys.length);
        return [ false, "" ];
    }

    console.log("easter.1300:   ENTER KEYS  ",keys);
    var e = keys.length - 1;
    var l1 = (keys[e-2] == "left") ? true : false;
    var m1 = (keys[e-2] == "mid") ? true : false;
    var r1 = (keys[e-2] == "right") ? true : false;
    var l2 = (keys[e-1] == "left") ? true : false;
    var m2 = (keys[e-1] == "mid") ? true : false;
    var r2 = (keys[e-1] == "right") ? true : false;
    var l3 = (keys[e] == "left") ? true : false;
    var m3 = (keys[e] == "mid") ? true : false;
    var r3 = (keys[e] == "right") ? true : false;
    //console.log("easter.1312:   DONE KEYS  m1=",m1, " l2=",l2, " r3=",r3);
    //console.log("easter.1312:   DONE KEYS  l1=",l1, " r2=",r2, " r3=",r3);

    if(m1 && l2 && r3) {
        console.log("easter.1309:  ******** CONNOR IS GREAT! *********", m1, l2, r3)
        return [ 2, "CONNOR IS GREAT!" ];
    }

    if(l1 && r2 && r3) {
        // Code: Left - Right - Right
        console.log("easter.1309:  ******** SECRETE ADMIN MENU *********", l1, r2, r3)
        return [ 1, "" ];
    }

    return [ 0, "" ];

}


// UTIL
// input menus from db, return menu struct for display
//      - organize sub-menu
//      - 
//  {top: ["item1.key", "item2.key", "item3.key+sub", "item4.key"], item3: ["1:item5", "2:item6:sub"], item6: ["1:item7", "2:item8"]}
//
export function processMenuItems(raw_menus) {
    var result = {}, top = {};
    result.top = [];
    if ((raw_menus === undefined) || (raw_menus === null))  return;

    raw_menus.sort(arraySeqAscSort);
    for (var i = 0; i < raw_menus.length; i++) {
        var menu = raw_menus[i];
        if ((typeof(menu.parent_hash) === "string") && (menu.parent_hash.trim().length > 3)) {
            var parent = menu.parent_hash;
            if(result[parent] === undefined) {
                result[parent] = [];
            }
            //console.log("menu.1306:      ",i,"       parent=",parent);
            if(menu.type === "menu") {
                result[parent].push(menu.hash+"+sub");
            } else {
                result[parent].push(menu.hash);
            }
        } else if(menu.type === "menu") {
            result.top.push(menu.hash+"+sub");
        } else {
            result.top.push(menu.hash);
        }
    }
    //console.log("menu.1321:  result=",result);

    return result;
}


// wake up at regular frequency, check if system processed it timely
//
export function checkRealTimeResponse(){
    var target = INFO.check_realtime_start + CONSTS.REALTIME_CHECK_INTERVAL;
    var now = Date.now();
    var delay = now - target;
    var max_delta = CONSTS.REALTIME_CHECK_INTERVAL * 3;
    var new_color = INFO.health_light_color;

    // determine console logging
    if (delay > max_delta) {
        //console.log("realtime.1545:                            ", INFO.realtime_fault_count, " !!!!!!!!!!!!!!  EXCESSIVE DELAY  ", (now - target), " @",now, " gap=", (now - INFO.last_realtime_fault));
        INFO.last_realtime_fault = now;     // start of real time response check
        INFO.realtime_fault_count = INFO.realtime_fault_count + 1;
    } else if (delay < 0) {
        console.log("realtime.1548:  !!!!!!!!!!!!!  REAL TIME ANTI-DELAY  ", (now - target), " @",now);
    }

    // determine light color
    if(delay > 800) {
        new_color = "#ff0000";  // red
    } else if (delay > 300) {
        new_color = "#ff6699";  // pink
    } else if (delay > 100) {
        new_color = "#ff9933";  // orange
    } else if (delay > 50) {
        new_color = "#ffff66";  // yellow
    } else {
        new_color = "#00cc00";  // green
    }

    //console.log("realtime.1610:  ------- PROCESS HEALTH LIGHT COLOR   delay=",delay, " new=", new_color);
    if (INFO.health_light_color !== new_color) {
        //console.log("realtime.1611:  ------------- CHANGE HEALT LIGHT COLOR  delay=",delay, " new=", new_color, " old=", INFO.health_light_color);
        INFO.health_light_color = new_color;
        window.dispatchEvent(INFO.health_light_event);      // tell UI to change light color
    }

    INFO.check_realtime_start = now;
    var timer = setTimeout(()=> {
        checkRealTimeResponse();
    },  CONSTS.REALTIME_CHECK_INTERVAL);

    // TODO: need to cancel timer on exit?

}


export function capitalize(word) {
  var out = ""
  var bits = word.split(". ")
  for (var i = 0; i < bits.length; i++) {
      var sentence = bits[i].trim();
      const lower = sentence.toLowerCase();
      var newbit = sentence.charAt(0).toUpperCase() + lower.slice(1);
      out = out + newbit + " ";  //". ";
  }
  return out;
}


// split up text into paragraphs and capitalized
//
export function processTutorialText(word) {
  var output = [], out;
  var pbits = word.split("\n")
  for (var j = 0; j < pbits.length; j++) {
        var bits = pbits[j].split(". ")
        out = "";
        for (var i = 0; i < bits.length; i++) {
            var sentence = bits[i].trim();
            const lower = sentence.toLowerCase();
            var newbit = sentence.charAt(0).toUpperCase() + lower.slice(1);
            out = out + newbit + " ";  //". ";
        }
        out = out + ".";
        output.push(out);
    }

  return output;
  //return word.charAt(0).toUpperCase() + lower.slice(1);
}


// check server to see if invite key is valid, if so, set INFO.invite_key
//      - store invite key in cookie
//      - if invalid key, set INFO.invite_key to "_invalid_"
//
export async function processInviteKey(invite_key){

    //var out = await dbCheckInviteKey(invite_key)
    var out = await dbCheckInviteKey(invite_key)
    if(out.error !== undefined) {
        console.log("invite.1611: --------------------- ERROR: INVITE_KEY = ", out.error);
        return false;
    }

    if(out.status === false) {
        // need to set the key with value, so user knows the key is bad
        invite_key = "_invalid_";       // ?i=<invite_key>
        console.log("invite.98: --------------------- ERROR INVITE_KEY INVALID = ", invite_key, " out=",out);
    } else {
        console.log("invite.98: +++++++++++++++++++++ RECEIVED INVITE_KEY = ", invite_key, " out=",out);
    }

    return invite_key;
}



// if there is an invite_key, first create user acct, initialize db state
//     - if drill-login, then create a user tied to this youtube chan
//     - if auto_run_mode (direct to drill), make sure we got the temp_uid
//
//export function  process_user_invite(invite_promise, from) {
export function  process_user_invite(from) {

    var temp_uid = auth.getTempUID(INFO.invite_key);       // get from cookie
    if(temp_uid !== false) {
        console.log("load_usr.1740:       USING COOKIE VALUE ", temp_uid);
        INFO.uid = temp_uid;        // from last time, need to delete cookie once we have real cred login
    }
    console.log("process_uinvite.1735: +++++++++++ USER INVITE COMPLETED  uid=",INFO.uid, " temp_uid_cookie=",INFO.temp_uid," youtube=",INFO.auto_run_mode, " (", from,")");

    function showSystemDownWarning(res) {
            console.log("load_usr.2190: !!!!!!!!!!!!!!!!!! LOGOUT: BAD INIT USER !!!!!!!!!!!!!!!!!!!!!!", res);
            var message = "SORRY SYSTEM IS UNAVAILABLE, PLEASE TRY AGAIN IN 10 MINUTES";
            //setCrash(message)
            //setShowUpdate(true);
    }

    // TODO: chicken & egg, need to sort out the demo mode
    // TODO: we want to  read the user state only once
    //        - anon login
    //        - call invite API, get temp_anon_uid (if no cookie)
    //        - call read user state with temp_anon_uid OR real fb_uid
    //
    var res = loadUserState(INFO.uid, INFO.invite_key)
    .then(res => {
        //console.log("invite.311:    loadUserState.res=",res);
        if (res === null) {
            console.log("process_invite.301: !!!!!!!!!!!!!!!!!! LOGOUT: INVITE BAD INIT USER !!!!!!!!!!!!!!!!!!!!!!", res);
            showSystemDownWarning(res);
            //auth.logout("/splash", State, setState);
        }
        return res;
    })
    .catch(res => {
        return null;
    })

}


// Login as anon user, receives temp_fb_uid from backend for late binding
//    - Use cases: auto_run_mode invite,  demo_anon mode
//    - has cookie (repeat visit), call /usr/start with prev temp_fb_uid
//    - no cookie, call backend get temp_fb_uid, then call /usr/start
//    - call with "placeholder" or temp_fb_uid
//    - (NOT for regular invite) login with real cred, call /usr/start with real fb_uid
//
//    - ...after this, call process_user_invite() that does loadUserState()
//
export async function process_temp_anon_login(State, setState) {

    // check if there is a cookie of anon ID from last time with same invite
    //
    var temp_uid = auth.getTempUID(INFO.invite_key);       // get from cookie
    if(temp_uid === false) {
        INFO.uid = CONSTS.ANON_PLACEHOLDER_ID;    // create temp user
        INFO.temp_uid = CONSTS.ANON_PLACEHOLDER_ID;    // create temp user
        //INFO.temp_uid = false;
    } else {
        // anon user tries another youtube drill and didn't convert last time
        //
        INFO.uid = temp_uid;        // from last time, need to delete cookie once we have real cred login
        INFO.temp_uid = temp_uid;
    }

    console.log("process_temp_login.209: +++++++++++ TEMP INVITE ANON LOGIN: invite=",INFO.invite_key," drill=",INFO.drill_hash, " tempUID=",temp_uid," uid=",INFO.uid);
    var login_promise = auth.anonLogin(State, setState)      // login as anon user
        .then(res => {
            // call invite if it's a brand new user, OR if user does not have the program add to the account

            console.log("process_temp_login.1802:         ANON INVITE LOGIN SUCCEEDED   invite_key=",INFO.invite_key, " uid=",INFO.uid,  " res=",res);
            if (INFO.uid == CONSTS.ANON_PLACEHOLDER_ID)  {
                //wait_for_invite = true;

                // call backend to create a user account if none exists
                // otherwise just read user state, don't create user
                //
                var invite_promise = inviteUser(INFO.uid, INFO.invite_key);
                console.log("process_temp_login.1846:         NEW ANON INVITE inviteUser() promise=",invite_promise);
                return invite_promise;
            } else {
                return null;        // not inviting, so no need to waiting for backend
            }

            //checkAuthResponse(State, setState, "anon_invite.1842");
        })

    console.log("process_temp_login.1853:        temp_anon_login() top level promise=", login_promise);
    return login_promise;
}




// convert to local days (from epoch), for easy leaderboard indexing
//
export function days_from_epoch(timestamp0, tz0) {
    var tz =  (tz0 === undefined) ?  CONSTS.EPOCH_DEFAULT_TZ : tz0;    // DEFAULT: to PST
    var timestamp =  (timestamp0 === undefined) ?  0 : timestamp0;    // DEFAULT: to PST
    
    //var last_timestamp = timestamp + (24 * 60 * 60 * 1000) - (tz * 60 * 1000);  // align UTZ to set to local midnight
    var adjust = tz * 60 * 60 * 1000;
    var epoch_days = Math.floor((timestamp - adjust) / CONSTS.EPOCH_MSEC_IN_A_DAY);    // find days at local time
    var remainder =  epoch_days % CONSTS.SCORE_MAX_DAYS_PER_REC;
    console.log("epoch-day.1183:       tz=",tz, "  epoch_days=",epoch_days, "  remainder=",remainder);
    return epoch_days;
}



// convert to local weeks (from epoch), for easy leaderboard indexing
//      - Jan 1st, 1970 is a Thu (day 4) ==> week 0
//
export function weeks_from_epoch(timestamp0, tz0) {
    var tz =  (tz0 === undefined) ?  CONSTS.EPOCH_DEFAULT_TZ : tz0;    // DEFAULT: to PST
    var days = days_from_epoch(timestamp0, tz);
    
    var remainder = (days - CONSTS.EPOCH_1970_WEEK_DAY_OFFSET) % 7;
    var weeks = (days - CONSTS.EPOCH_1970_WEEK_DAY_OFFSET) / 7;
    var epoch_weeks = Math.floor(weeks);
    //console.log("weeks.571:       epoch days=",days, "  weeks=",weeks, "  epoch_weeks=",epoch_weeks, " remainer_days=",remainder);
    return epoch_weeks;
}


// setup game scheme (motions)
//
export function setupScheme(input_motion_hash, input_param1, input_param2) {
    var schemes = [];

    var motions = INFO.db_motions.filter(motion => { return motion.motion_hash == input_motion_hash });
    motions.sort(arraySeqAscSort);
    for (var i = 0; i < motions.length; i++) {
        var motion = motions[i];
        var scheme = {};
        scheme.x = motion.x;
        scheme.y = motion.y;
        scheme.move = motion.move;
        scheme.type = motion.type;
        scheme.seq = motion.seq;

        if ((typeof(motion.duration) == "string") && (motion.duration.match("_param") !== null)) {
            // PROCESS DURATION: substitute params from drill, make sure Infinity is good
            //
            //if ((motion.duration !== undefined) && (typeof(motion.duration) == "string")) {
                var param = motion.duration.trim();
                switch(param) {
                    case "_param1_":
                        //console.log("game.997:       CUSTOM param1=",input.param1);
                        scheme.duration = input_param1;
                        break;
                    case "_param2_":
                        scheme.duration = input_param2;
                        break;
                    default:
                        console.log("game.1004:       UNKNOWN duration!    ",motion.duration);
                        scheme.duration = "ERROR";
                        break;
                }
            //}
            console.log("game.993:  CUSTOM DURATION..... motion.duration=",motion.duration, "  scheme=",scheme);
        } else {
            scheme.duration = motion.duration;
            console.log("game.987:  NORMAL DURATION..... motion.duration=",motion.duration, "  scheme=",scheme);
        }
        schemes.push(scheme);
    }
    console.log("game.990:  MOTION SCHEME LOADED   schemes=",schemes.length);
    return schemes;
}



// AMDIN TOOL: 
// Switch to players owned by the user
//
export function AdminSwitchUser(user) {

    console.log("switch_user.2236:      . . .  LOADING USER SETTING:  ",user);
    INFO.avatar = user.avatar;
	INFO.email = user.email;
	INFO.uid = user.firebase_uid;			// uid for firebase bucket
    //setState('photo', user.avatar);
    INFO.current_score = 0; 


    /*
    INFO.db_today= null;         // store a copy of today drills from db (merged progs)
    INFO.db_drills= null;        // all drills qualified by user
    INFO.db_menus= null;         // all drills qualified by user
    INFO.db_sections= null;      // all drills qualified by user
    INFO.db_motions= null;       // finger game motions
    INFO.db_states= null;        // tutorial & other states
    INFO.db_leaders= null;       // leader boards
    INFO.db_scores= null;        // daily scores
    //INFO.db_contents= null,      // contents like tutorial assets
    //INFO.db_org= null,           // user home org, get branding from here
    //INFO.db_tutorials= null,     // tutorial read states
    //INFO.db_players= null,       // for god mode
    */
}
    

// TOOL
// READ USER STATE FROM SERVER: 
//    - main read routine to set up a user in the app
//    - when all done, wake up Learn to simulate a click to start a drill
//
export async function loadUserState(uid, invite_key) {
        
    if (INFO.bot_slave_mode) {
        // if fake user, only load enough to run the drill
        //

        return out;
    }

        //INFO.server_axos_version = getServerVersion();  // BAD: CORS issue

        var out = startUser(uid, invite_key)
        .then(user =>{
            if ((!user) || (!user.version)) {
                console.log("load_usr_state.1799: !!!!!!!!!!!!!!!!!! BAD INIT USER !!!!!!!!!!!!!!!!!!!!!!", user);
                return null;
            }

            console.log("######################################### INIT USER COMPLETE #########################################", user);
            console.log("load_usr_state.1824:   ====> INFO.localhost=",INFO.localhost, " current version=",INFO.axos_version);
            if (INFO.localhost === true) {
                console.log("load_usr_state.2455:   ====> LOCALHOST  INFO.server_axos_version=",user.version);
            }


            // read https://storage.googleapis.com/app.axos.cc/version for server version
            //
            INFO.server_axos_version = parseInt(user.version);  // from static asset bucket

            if (INFO.server_axos_version > INFO.axos_version) {
                console.log("load_usr_state.2466: ++++++++++++++ NEW VERSION AVAIL ++++++++++++++  old=", INFO.axos_version, "  new=", INFO.server_axos_version);
                INFO.show_download = true;
            }

            if (INFO.db_menus === null) {
                ReadMenuData()
                .then(rmenus => {
                    console.log("index.125:  MENU FROM DB  ", rmenus);
                    var menu_keys = processMenuItems(rmenus);
                    INFO.menu_data = rmenus;
                    INFO.menu_keys = menu_keys;
                    return menu_keys;
                })
            } else {
                var menu_keys = processMenuItems(INFO.db_menus);
                INFO.menu_data = INFO.db_menus;
                INFO.menu_keys = menu_keys;
            }

            if (INFO.db_states === null) {
                //var user_hash = "usr:" + makeUserKey(INFO.email);
                var user_hash = makeUserHash(INFO.email);
                ReadStateData(user_hash)
                .then(states => {
                    INFO.db_tutorials = processStateItems("tutorials", states);
                    INFO.db_scores = processStateItems("scores", states);
                })
            } else {
                INFO.db_tutorials = processStateItems("tutorials", INFO.db_states);
                INFO.db_scores = processStateItems("scores", INFO.db_states);
                console.log("startUser.238:  ================> DB_SCORES= ", INFO.db_scores);
            }


            if (INFO.db_org === null) {
                //var user_hash = "usr:" + makeUserKey(INFO.email);
                var user_hash = makeUserHash(INFO.email);
                ReadHomeOrgData(user_hash)
                .then(org => {
                    INFO.db_org = org[0];
                    console.log("startUser.247:  ================> NEW DB_ORG= ", INFO.db_org);
                })
            } else {
                console.log("startUser.238:  ================> DB_ORG= ", INFO.db_org);
            }

            if ((INFO.god_mode === true) && (INFO.god_players !== null)){
                // restore player list to continue god_mode
                INFO.db_players = JSON.parse(JSON.stringify(INFO.god_players));
            }

            // anon overrride
            if (INFO.anon_mode === true) {
                //INFO.db_org = {"name": "AXOS DEMO"};
                var org_name = INFO.db_org.name;
                if(INFO.direct_start_mode === true) {
                    INFO.db_org = {"name": "YOUTUBE: "+org_name};
                } else {
                    INFO.db_org = {"name": org_name+" (DEMO)"};
                }
            }

            // KLUDGE: **** NOT SURE IF THIS SHOULD BE HERE! ****
            if ((INFO.org_key !== null) && (INFO.drill_hash !== null)) {
                //ReadUserStateInfo(mode);
                console.log("startUser.2024:         SENDING WAKEUP SIGNAL TO Read User State ");
                window.dispatchEvent(INFO.has_user_state_event)
                INFO.has_user_state = true;     // in case <Learn> is not up yet
            }

        })
        .catch(err =>{
            console.log("startUser.111: ******* ERROR ", err)
            return null
        })

        return out;
    }


    // UTIL
    // supports pre-flight message of acheiving the next target record
    //
    export function getPersonalTarget() {
        var rec = INFO.personal_record;
        if (rec.next_rec  && rec.field) {
            console.log("personal.1864:   ....... rec=",rec);
            var warnings = [], warning = {};
            var field = (rec.field[0]) ? rec.field[0].toUpperCase() : rec.field.toUpperCase();
            warning.title = "YOUR "+field+" TARGET: ";
            warning.value = Math.floor(rec.next_rec * 10) / 10;
            warnings.push(warning);
            return warnings;
        } else {
            return null;
        }
    }



    // UTIL
    // determine direction of perf target (if lower the better)
    //
    export function low_target_field_type(target) {
        var small_better = true;
        switch(target) {
            case "sc0":     // hese are bigger the better
            case "sp0":
            case "sl0":
            case "sb0":
            case "a04":
                small_better = false;
                break;
            default:
                break;
        }
        return small_better;
    }



    export function qualifiedBoard(target_hash, subtype0) {
        var bits = target_hash.split("+");
        var field = bits[1];
        var good = false;
        var subtype = (subtype0 === null) ? "" : subtype0.toLowerCase();
        switch(field) {
            case "t00":
                if((subtype === "practice") || (subtype === "skill")) {
                    good = true;
                }
                //good = true;        // KLUDGE: UNTIL WE CLEAN UP SESSION DATA
                break;
            case "r04":
                if(subtype === "game") {
                    good = true;
                }
                good = true;        // KLUDGE: UNTIL WE CLEAN UP SESSION DATA
                break;
            case "r00":
            case "r01":
                if((subtype === "perf") || (subtype === "performance")) {
                    good = true;
                }
                good = true;        // KLUDGE: UNTIL WE CLEAN UP SESSION DATA
                break;
            case "sc0":
                good = true;
                break;
        }
        //console.log('qualify.1237:      target_hash=',target_hash, " subtype=",subtype, " good=",good);
        return good;
    }


    export function getLeaderBoardTitle(hash, short) {
        var title = "";
        switch(hash){
            case "geo:world:_:_:_":
                title = (short === true) ? "WORLD" : "WORLD RECORD"
                break;
            case "org:usa:sf:axos":
                title = (short === true) ? "AXOS" : "AXOS RECORD"
                break;
            case "grp:axos:public":
                title = (short === true) ? "AXOS" : "AXOS PUBLUC"
                break;
            case "prg:axos:connor:1":
            default:
                title = (short === true) ? "PROG" : "PROGRAM RECORD"
                break;
        }
        return title;
    }

    export function getDrillTitle(hash) {
        if (hash === undefined) {
            return "none";
        }
        var bits = hash.split("+");
        var drill_hash = bits[0];
        var target = bits[1];
        var title = "", type = null;
        switch(drill_hash){
            case "scr:score:basic":
                title = "OVERALL SCORES"
                type = "score"
                break;
            default:
                var drills = INFO.db_drills.filter(drill => {return(drill.hash == drill_hash)})
                if(drills[0] === undefined) {
                    title = "SCORES"
                    type = "score"
                } else {
                    title = drills[0].name;
                    type = drills[0].type;
                }
                break;
        }

        // <TypeIcon Type={type} />

        var out = title +" - "+ target;
        return out;
    }


    // make unique React key from target_hash
    //
    export function getDrillID(hash) {
        if (hash === undefined) {
            return "none";
        }

        return hash;
    }


    // support multiele version of video url (youtube, vimeo)
    //
    export function makeVideoLink(hash, from) {
        //console.log("video.2188:  START MAKE VIDEO LINK hash=",hash, " from=",from);
        if ((hash === null) || (hash === undefined) || (hash === "")) {
            return null;
        }
        
        //https://firebasestorage.googleapis.com/v0/b/axo-sports.appspot.com/o/test_videos%2FDaZoKpc6WwMLnqhVu4kWf5MtoU22_1618804668524.webm?
        //alt=media&token=85ca5771-7084-420c-ac67-bf802c4db033
        if (hash.includes("axos") === true) {
            console.log("video.2312:    SKIP MAKE VIDEO LINK   hash=",hash, " from=",from);
            return hash;        // not really a hash, return
        }

        var url = hash;
        var bits = hash.split(":");      // encoded: "y:"=youtube, "v:"=vimeo
        switch(bits[0]) {
            case "y":
                url = makeYoutubeLink(hash);
                break;
            case "v":
                url = makeVimeoLink(hash);
                //setVimeoType(true);
                break;
            default:
                if (hash.includes('youtu') === true) {
                    url = hash;
                    //console.log("video.4087:  XXXX..GOT YOUTUBE url=",hash);
                } else if (hash.includes('vimeo') === true) {
                    // special auto-gen recorded vimeo vids
                    //
                    // src: https://vimeo.com/584700710
                    var ubits = hash.split("/");
                    var id = ubits[ubits.length - 1];
                    url = "https://player.vimeo.com/video/"+id+VIMEO_POST;

                } else {

                    //url = "https://player.vimeo.com/video/"+hash+VIMEO_POST;
                    url = hash;
                    //console.log("video.2216:                ------ url=",url);
                }
                break;
        }
        //console.log("video.2318:  MAKE VIDEO LINK   hash=",hash, " url=",url, " from=",from);
        return url;
    }



    // support multiele version of video url (youtube, vimeo)
    //
    export function makeFootageVideoLink(footage, from) {
        //console.log("video.2188:  START MAKE VIDEO LINK hash=",hash, " from=",from);
        if ((footage === null) || (footage === undefined) || (footage === {})) {
            return null;
        }

        var url = null;
        switch(footage.source) {
            case "youtube":
                url = makeYoutubeLink("y:"+footage.video_id);
                break;
            case "vimeo":
                url = makeVimeoLink("v:"+footage.video_id);
                break;
        }
        //console.log("video.2341:  MAKE FOOTAGE VIDEO LINK   src=",footage.source, " url=",url, " from=",from);
        return url;
    }



    // parse "v:<id>:<start_sec>"
    // TODO: need to support start time
    //
    //     - VIMEO_POST ="?autoplay=1&loop=1&autopause=1&muted=1&controls=0"
    export function makeVimeoLink(hash) {
        var hbits = hash.split(":");      // encoded: "y:"=youtube, "v:"=vimeo
        var ubits = hbits[1].split("/");
        var start = (hbits[2] === undefined) ?  "" : "&t="+hbits[2];
        var id = ubits[ubits.length - 1];
        const vurl = "https://player.vimeo.com/video/"+id+VIMEO_POST+start;
        //console.log("vimeo.2357:    MAKE VIMEO LINK  hash=",hash, "  url=", vurl);

        return vurl;
    }


    // format:  [v || y]:<video_id>:<start>:<end>
    //          foot:[vimeo || youtube]:<video_id>
    //          https://vimeo.com/<video_id>
    //
    export function decodeVideoHash(hash) {
        var video_id = null, video_start = 0, video_end = null;
        var sbits = hash.split("?");
        var hbits = sbits[0].split(":");
        var wbits = hash.split("/");
        var type;

        if (wbits[0] === "https:") {
            type = "vimeo";
            video_id = wbits[3];
        } else 

        if (hbits[0] === "foot") {
            type = hbits[1];
            video_id = hbits[2];

        } else {
            var ubits = hbits[1].split("/");
            var id = ubits[ubits.length - 1];

            video_id = id;
            video_start = (hbits[2] === undefined) ?  null : parseInt(hbits[2]);
            video_end = (hbits[3] === undefined) ?  null : parseInt(hbits[3]);
            type = hbits[1];
        }
        console.log("vid_decode.2782:      HASH_DECODE   hash=",hash, "  type=", type, " video_id=",video_id, " wbits=",wbits);

        return [ video_id, video_start, video_end, type ];
    }



    // youtube: https://www.youtube.com/embed/gV9b6bMY6CA?t=334&enablejsapi=1
    export function makeYoutubeLink(hash) {
        var [ video_id, video_start, video_end ] = decodeVideoHash(hash);
        //console.log("make_youtube.2247:   .......SETUP  hash=",hash," id=",video_id, " start=",video_start);

        var start = (video_start === undefined) ?  "" : "&start="+video_start;
        var end = (video_end === undefined) ?  "" : "&end="+video_end;

        //const vurl = "https://www.youtube.com/embed/"+video_id+"?enablejsapi=1&rel=0&modestbranding=1&autoplay=1&loop=1"+start+end+"&playlist="+id;
        const vurl = "https://www.youtube.com/embed/"+video_id+"?enablejsapi=1";
        return vurl;
    }



    // Note: Keeping it narrow for arena training (aspect = 1.33), could be much wider (aspect > 1.77)
    //
    export function set_webcam_resolution(resolution) {
        var ht = null;
        // init camera resolution (640 x 480) or (360 x 270)
        switch(resolution) {
            case "high":
                ht = 720;
                INFO.webcam_oheight = ht;
                INFO.webcam_owidth = (CONSTS.WEBCAM_BASE_ASPECT * ht); // 960;
                INFO.show_stats = false;        // for recording demo
                INFO.show_facemask = false;        // for recording demo
                INFO.show_skeleton = false;
                break;
            case "med":
                ht = 480;
                INFO.webcam_oheight = ht;
                INFO.webcam_owidth = (CONSTS.WEBCAM_BASE_ASPECT * ht); // 640;
                INFO.show_stats = false;        // for recording demo
                INFO.show_facemask = false;        // for recording demo
                INFO.show_skeleton = false;
                break;
            case "low":
            default:
                INFO.webcam_oheight = CONSTS.WEBCAM_BASE_HEIGHT;    // new is 270, 
                INFO.webcam_owidth = CONSTS.WEBCAM_BASE_WIDTH_FN();      // new is 360,  aspect 1.33
                INFO.show_stats = true;
                INFO.show_skeleton = true;
                INFO.show_facemask = true;        // for recording demo
                break;
        }

        const ww = INFO.webcam_owidth;
        const wh = INFO.webcam_oheight;
        console.log("init_webcam_dim.190:    REQUESTED WEB CAM RESOLUTION:    webcam_owidth=",INFO.webcam_owidth, "  webcam_oheight=",INFO.webcam_oheight);

        return [ww, wh];
    }

    
    export function parseJSON(string) {
        if ((string === undefined) || (string === null) || (string.length <= 2)) {
            return {};
        }

        try {
            var json = JSON.parse(string);
            return json;
        }
        catch (e) {
            console.log("util.2356: BAD JSON.parse  ",e,": ",string);
            // Return a default object, or null based on use case.
            return {}
        }
    }
    

    // special custom run settings defined in drill
    //     - speed: video player speed, slow is easier
    //
    //
    export function parseSliceParams(params0) {
        var params = null;
        if ((!params0) || (params0 == "") || (params0.length < 6)) {
             return {};
        }

        // MUST CLEAR ALL FIRST
        //
        INFO.practice_run_mode = "reps";   // perf: # of cones used

        INFO.mock_custom_speed = null;
        INFO.mock_custom_leader = null;
        INFO.mock_custom_cones = null;
        INFO.custom_min_loop_px = null; 
        INFO.record_output = false;      // record agility game for intro

        INFO.override.show_ratio = false;
        INFO.override.show_grid = false;
        INFO.override.show_ht = false;

        params = parseJSON(params0);
        console.log("param.2436:   = = = START Slice Params    input=", params0,  " params=",params);
        Object.keys(params).forEach(function(key,index) {
            // key: the name of the object key
            // index: the ordinal position of the key within the object 
            var param = params[key];
            if(param === "true") param = true;
            if(param === "false") param = false;

            switch(key) {
                // ALTER PER-DRILL PARARMS
                case "dr_mode":
                case "mode":
                    INFO.practice_run_mode = param;   // perf: ["reps", "timer"]
                    break;
                case "dr_duration":
                case "duration":
                    INFO.practice_run_duration = param;   // in seconds
                    break;
                case "dr_delay":
                case "delay":
                    var delay = parseInt(param);   // chain delay
                    INFO.drill_chain_delay = (delay) ? delay : CONSTS.DEFAULT_CHAIN_DELAY;      // Note: should this be generalized?
                    break;
                case "dr_cones":
                case "cones":
                    INFO.mock_custom_cones = param;   // perf: # of cones used
                    break;
                case "dr_loop_px":
                case "loop_px":
                    INFO.custom_min_loop_px = param;   // skill: min loop distance, "loop_px": 35
                    break; 
                case "dr_loop_msec":
                case "loop_msec":
                    INFO.custom_min_loop_msec = param;  // skill: min loop detect time, 600,
                    break;

                // ALTER GAME PARARMS
                case "gm_speed1":
                case "speed1":
                    //
                    break;
                case "gm_speed2":
                case "speed2":
                    //
                    break;
                case "gm_record":
                case "mk_record":
                    INFO.record_output = param;      // record agility game for intro
                    break;

                // ALTER MOCK PARARMS
                case "mk_speed":
                case "speed":
                    INFO.mock_custom_speed = param;   // mock: footage replay speed
                    break;
                case "mk_leader":
                case "leader":
                    INFO.mock_custom_leader = param;  // mock: timer displayed pre-kick
                    break;

                // ALTER DEFENDER PARARMS
                case "df_cog":
                case "defend_cog":
                    INFO.defend_cog = parseInt(param);
                    break;
                case "df_acc":
                case "defend_acc":
                    INFO.defend_acc =  (param) ? parseFloat(param) : CONSTS.DEFENDER_ACCELERATION;
                    break;
                case "df_gap":
                case "defend_gap":
                    INFO.defend_gap = (param) ? parseFloat(param) : CONSTS.DEFENDER_GIVE_UP_GAP_PCT;
                    break;


                // ALTER ANNOTATION DISPLAY
                case "show_ratio":
                    INFO.override.show_ratio = param;
                    break;
                case "show_grid":
                    INFO.override.show_grid = param;
                    break;
                case "show_ht":
                    INFO.override.show_ht = (param === true) ? true : false;
                    break;

                // ALTER MISC
                case "train_set":
                    INFO.ai_train_set = param;   // ai_train: total set for ai data collection
                    break;
                case "auto_run":
                    INFO.direct_start_mode = true;
                    INFO.auto_run_mode = param;   // simulate a url atuo start
                    break;

            }
            console.log("param.254:       .  .  .  .  PARAM   field=", key, " val=",param);
        });

        //console.log("params.2477:       ++++++++ RETURN PARAM =", params);
        return params;
    }


//
// TEST VIMEO DOWNLOAD CODE
//
// src: https://gist.github.com/SpenceDiNicolantonio/326e98f7d0687ca39e68ae49909d42a6
//

/**
 * Finds and downloads all embeded Vimeo videos.
 */
const cors_proxy_url="https://cors-anywhere.herokuapp.com/"
//const cors_proxy_url="https://cors.io/?"
export function downloadEmbededVideos() {
	
	// Find Vimeo embed frame
	var embedFrames = document.querySelectorAll('iframe[src*="player.vimeo.com"]');
	
	// No embed frames found?
	if (!embedFrames.length) {
		console.error("Failed to identify embeded video frame");
		return;
	}
	
	// Retrieve embed source
	for (var i = 0; i < embedFrames.length; i++) {
        //var url = cors_proxy_url+ embedFrames[i].src;
        var url = embedFrames[i].src;

		console.log('Requesting source for embedded video: ', embedFrames[i], " url=",url);
		//getSource(embedFrames[i].src, function(response) {
		getSource(url, function(response) {
			var mp4Url = find_mp4_url(response);
			console.log('vimeodl.2513:  Downloading "' + mp4Url + '"...');
			//downloadFile(mp4Url);

            return mp4Url;
		});
	}
}


/**
 * Retrieves content source at given URL.
 * @param {string} url URL from which content source will be retrieved
 * @param {function} callback Called with the retrieved source on successful retrieval
 */
export function getSource(url, callback) {
	var xhr = new XMLHttpRequest();
	xhr.onreadystatechange = function() {
		if (xhr.readyState == 4 && xhr.status == 200) {
			callback(xhr.responseText);
		}
	};
	xhr.open("GET", url, true);
	xhr.send(null);
};

/**
 * Finds mp4 URL within Vimeo embed source.
 * @param {string} source Source to search for mp4 URL
 * @return {string} The mp4 URL
 */
// target: url\":\"https://skyfire.vimeocdn.com/1642160848-0xd1961550a0783c5b667a23d052e9e0bb0cb46486/d504ad68-a41c-4e06-b16c-d712f43e2a32/sep/video/ac2c8a4b,e76a16a2,7290c1de/master.m3u8?query_string_ranges=1\"}}},\"progressive\":[{\"profile\":\"164\",\"width\":496,\"mime\":\"video.mp4
//
//  - find url to start
//  - find mp4 to end
//  - find url to start
//
// SYNC:  server.utilServer.js
//
export function find_mp4_url(source) {
    var url;
    if (!source) return null;

    var bits = source.split('\"')
    for (var i = 0; i < bits.length; i++) {
        var bit = bits[i];
        var mp4 = bit.match(/mp4/);
        var aka = bit.match(/akamai/);
        if ((bit[0] === "h") && (mp4 !== null) && (aka !== null)) {
            console.log(i+":    . . . . . VIMEO URL   "+bit)
            url = bit;
        }
    }
    console.log("vim_url.470:   _ _ _ _ Found Vimeo URL=",url)
	return url;
}

//function findMp4Url(source) {
//	return source.match(/"url"\s*:\s*"(https?:\/\/[^"]+\.vimeocdn\.com\/[^"]+\.mp4(\?([^"]+=[^"]+;?)+)?)"/)[1];
//}

export function findVideoType(url){
    var player_type;
    if (!url) {
        player_type = null;     // undecided, could be from Footage or is a <Gif> or <replay>
    } else if(url.includes("youtu") === true) {
        player_type = "youtube";
    } else {
        player_type = "vimeo";
    }
    console.log("vidtype.2585:   _ _ _ _ _ _ _ DETERMINE VIDEO TYPE    player_type=",player_type, " url=",url);

    return player_type;
}


/**
 * Downloads the file at a given URL.
 * @param {string} url The URL of the file to download
 */
function downloadFile(url) {
	var filename = url.substring(url.lastIndexOf("/") + 1).split("?")[0];
	var xhr = new XMLHttpRequest();
	xhr.responseType = 'blob';
	xhr.onload = function() {
		var a = document.createElement('a');
		a.href = window.URL.createObjectURL(xhr.response);
		a.download = filename;
		a.style.display = 'none';
		document.body.appendChild(a);
		a.click();
		//delete a;
	};

    console.log("vimeo_dl.2478:   *****  url1=",url)
	xhr.open('GET', url);
	xhr.send();
}



// NOTE: NOT USED THIS WAY ANYMORE
//
export function processGifVideo(url, drill_key) {
    if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
        //url = cors_proxy_url + url;     // get around cors issue, may need visit *** http://cors-anywhere.herokuapp.com/corsdemo ****
    }

    var options = {
        gifWidth: 50,
        gifHeight: 35,
        interval: 0.2,
        numFrames: 35,
        frameDuration: 1,     // slows down the render, make size bigger
        sampleInterval: 1,    // affects processing time, sampling the pixels, smaller = higher quality
        numWorkers: 2,
        video: [
            //'https://aip.axos.cc/v1/bucket/splash/joner.mp4'
            url
        ],
    }
    
    gifshot.createGIF(options, function(obj) {
        if(!obj.error) {
            var image = obj.image;

            var animatedImage = document.getElementById('output');
            animatedImage.src = image;
            writeGifFile(image, drill_key);
            //console.log("Gif.63:  after gifshot.create_gif() image=",image);
        }
    });
}



    // PWA management
    //     - sets INFO.pwa_install_state
    //     - "use_safari": IOS & -Chrome: Inform to switch to Safari
    //     - "add_ios_home": IOS & Safari & -PWA: Show instructions to "save to home"
    //     - "add_android_home": Andoid & Chorme & -PWA: Show button to "save to home"
    //     - "no_change": * & PWA: Do nothing
    //
    export async function setPWANotificationState() {
        var pwa = await isPWAInstalled();
        var browser = INFO.browser.browser;
        var make = INFO.device.make;
        INFO.pwa_install_state = CONSTS.PWA_NO_CHANGE;
        if(pwa === "browse") {
            if (make === "ios") {
                if (browser.match(/safari/ig) !== null) {
                    console.log("Splash_pws.273:           +  +  <SHOW IOS INSTRUCTION SAVE_TO_HOME>  FOUND IOS & SAFARI & -PWA:   dev=",make, " browser=",browser, " pwa=",pwa);
                    INFO.pwa_install_state = CONSTS.PWA_ADD_IOS_HOME;
                //} else if (browser.match(/chrome/ig) !== null) {
                } else {
                    console.log("Splash_pws.273:           +  +  <ASK TO SWITCH TO SAFARI>     FOUND IOS & CHROME & -PWA:   dev=",make, " browser=",browser, " pwa=",pwa);
                    INFO.pwa_install_state = CONSTS.PWA_USE_SAFARI;
                }
            } else if (make === "android") {
                console.log("Splash_pws.272:           +  +  <DISPLAY NATIVE SAVE_TO_HOME BUTTON>  FOUND ANDROID & -PWA:   dev=",make, " browser=",browser, " pwa=",pwa);
                INFO.pwa_install_state = CONSTS.PWA_ADD_ANDROID_HOME;
            }
        } else {
                console.log("Splash_pws.281:           +  +  <ALREADY A PWA>   dev=",make, " browser=",browser, " pwa=",pwa);
        }

        console.log("splash.399:     # # # # # # #  PWA STATE:  dev=",make, " browser=",browser, " pwa=",pwa, " localhost=",INFO.localhost, " STATE=", INFO.pwa_install_state);
    }


    async function isPWAInstalled() {
        var status = "browse";
        if((window.navigator !== undefined) && window.navigator.standalone === true) {
            console.log("splash.293:       .  .  .  .  FOUND IOS PWA:  standalone=",window.navigator.standalone);
            status = "pwa";     // For iOS
        }
        if(window.matchMedia('(display-mode: standalone)').matches === true) {
            console.log("splash.3062:       .  .  .  .  FOUND ANDROID PWA:  matchMedia=",window.matchMedia);
            status= "pwa";  // For Android
        }

        if (navigator.getInstalledRelatedApps !== undefined)  {
            //const relatedApps = await navigator.getInstalledRelatedApps()  // for desktop
            var apps = await navigator.getInstalledRelatedApps()  // for desktop
            apps.forEach((app) => {
                console.log("splash.297:       .  .  .  .  FOUND DESKTOP PWA:  id=",app.id, " platform=",app.platform, " url=",app.url);
                status = "pwa";
            });
            //console.log("splash.308:       .  .  .  .  Interim DESKTOP PWA:  status=",status);
        }

        //var final = Promise.all([pwa]).then((res) => {return res})
        //console.log("splash.309:       .  .  .  .  PWA REUSLT: ",status);
        return status;
    }



// UTIL: copy to clipboard
//
export function copyToClipboard(elem) {
    var copied = null;
    var targetId = "_hiddenCopyText_";   // create hidden text element, if it doesn't already exist
    var isInput = elem.tagName === "INPUT" || elem.tagName === "TEXTAREA";
    var origSelectionStart, origSelectionEnd;

    if (isInput) {
        // can just use the original source element for the selection and copy
        target = elem;
        origSelectionStart = elem.selectionStart;
        origSelectionEnd = elem.selectionEnd;
    } else {
        // must use a temporary form element for the selection and copy
        target = document.getElementById(targetId);
        if (!target) {
            var target = document.createElement("textarea");
            target.style.position = "absolute";
            target.style.left = "-9999px";
            target.style.top = "0";
            target.id = targetId;
            document.body.appendChild(target);
        }
        target.textContent = elem.textContent;
    }

    // select the content
    var currentFocus = document.activeElement;
    target.focus();
    target.setSelectionRange(0, target.value.length);
    
    // copy the selection
    var succeed;
    try {
    	  succeed = document.execCommand("copy");
    } catch(e) {
        succeed = false;
    }

    // restore original focus
    if (currentFocus && typeof currentFocus.focus === "function") {
        currentFocus.focus();
    }
    
    if (isInput) {
        // restore prior selection
        elem.setSelectionRange(origSelectionStart, origSelectionEnd);
    } else {
        // clear temporary content
        target.textContent = "";
    }
    copied = elem.value;

    return copied;
}


// convert an array to an object
//
export function array2Map(arr, field) {
    var out = {}
    for (var i = 0; i < arr.length; i++) {
        var ele = arr[i];
        var key = ele[field];

        out[key] = ele;
    }
    return out;
}


// convert an object to an array
//
export function map2Array(obj) {
    var out = []
    if (!obj) { return []};
    //if (typeof(obj) === "array") { return obj};
    if (typeof(obj) === "array") { 
        obj = JSON.parse(JSON.stringify(obj));     // users may still be a string
    };

    for (var i in obj) {
        var ele = obj[i];
        out.push(ele);
    }
    return out;
}



// UTIL: Cacluate score from STATS, based on table
//
// src: https://docs.google.com/spreadsheets/d/1KWYuUg9j9NIMC_g8hb9QIGZXMLTZ92YFCgp8bBydTjQ/edit#gid=960212473
//
export function calcSessionScore(drill, STATS) {
    var inp = null;
    if (!drill) { console.error("calc_score.3197:   ! ! ! ! ! BAD DRILL  drill=",drill, "  STATS=",STATS); return; };

    var algo = {}
    algo.bumps = [0, 0.5, 1, 1.5, 2, 3, 4, 5, 6, 7, 7, 7, 7, 7, 7, 7, 7, 7];
    algo.low = 5;      // worst score below algo.base threshold
    algo.steps = 5;

    var cum = 0;
    algo.cums = [];
    for (var i = 0; i < algo.bumps.length; i++) {
        var bump = algo.bumps[i];
        cum = cum + (bump * algo.steps);
        algo.cums[i] = cum;         // prep the table
        //console.log("calc_score.3207:        . . . i=",i," bump=",bump, " cum=",cum);
    }

    var type = drill.type;
    type = (drill.tag === "juke") ? "juke" : type;
    switch(type) {
        case "drill": 
        case "skill": 
        case "condition": 
            algo.dec_mode = true;       // lower value the higher score
            algo.base = 75;     // below this threshold, all same low score
            algo.unit = 1;
            inp = STATS.t00;
            break;
        case "perf": 
            algo.dec_mode = true;       // lower value the higher score
            algo.base = 1570;       // below this threshold, all same low score, 1700, 2070
            algo.unit = 18;         // 15
            inp = STATS.r00;
            break;
        case "juke": 
            algo.dec_mode = false;       // lower value the higher score
            algo.base = 2.5;     // below this threshold, all same low score, 7.5, 22, 18, 16
            algo.unit = 0.9;      //0.5, 1
            inp = STATS.c01;
            break;
        case "game": 
            algo.dec_mode = true;       // lower value the higher score
            algo.base = 335;     // below this threshold, all same low score
            algo.unit = 5;
            inp = STATS.r04;        // use a04 and r04_cnt for bonus
            break;
        case "mock": 
            algo.dec_mode = true;       // lower value the higher score
            algo.base = 210;     // below this threshold, all same low score
            algo.unit = 4;
            inp = STATS.r05;        // use a05 and r05_cnt for bonus
            break;
    }
    if (inp < 0) { return 0};       // invalid input

    //for (var inp = 29; inp >= 4.5; inp= inp - algo.unit) { }      // for testing
    var score = null;
    if (algo.dec_mode === true) {
        var bucket = Math.abs((inp - algo.base) / algo.steps / algo.unit);
        var idx = parseInt(bucket) + 1;
        var frac0 = (1 - (bucket - parseInt(bucket)));
        var frac1 = frac0 * (algo.bumps[idx] * algo.steps);
        var out = Math.round(algo.low + algo.cums[idx] - frac1);
        score = (inp >= algo.base) ? algo.low : out;
        console.log("calc_score.3218:   SS0_SCORE   DEC . .  inp=",inp, "  SCORE=",out, " drill=",drill, " tag=",drill.tag, " base=",algo.base, " unit=",algo.unit," idx=",idx, " algo.bumps=",algo.bumps[idx], " algo.low=",algo.low," bucket=",bucket.toFixed(2), " frac0=",frac0.toFixed(2), " frac1=",frac1.toFixed(2),  " cums=",algo.cums[idx])
    } else {
        var bucket = Math.abs((inp - algo.base) / algo.steps / algo.unit);
        var idx = parseInt(bucket) + 1;
        var frac0 = (1 - (bucket - parseInt(bucket)));
        var frac1 = frac0 * (algo.bumps[idx] * algo.steps);
        var out = Math.round(algo.low + algo.cums[idx] - frac1);
        score = (inp <= algo.base) ? algo.low : out;
        console.log("calc_score.3399:   SS0_SCORE   INC . .  type=",type,"  inp=",inp, "  SCORE=",out,  " base=",algo.base, " unit=",algo.unit," idx=",idx, " bucket=",bucket.toFixed(2), " frac0=",frac0.toFixed(2), " frac1=",frac1.toFixed(2),  " cums=",algo.cums[idx])
    }

    return score;
}



export const initAudio = () => {
    if(!INFO.audio) {
        INFO.audio = new Audio();       // initialize on click and re-use later, workaround for IOS auto-play block
        console.log("dashbd.1936:    # # # # # # #   INITIALIZED AUDIO  audio=", INFO.audio);
    }
}


// for keyboard control of video player
//
export function findSkipSteps(shift, ctrl, alt) {
    var steps =  null;

    if ((ctrl === true) && (shift === true)){
        steps = 3000;
    } else if (ctrl === true){
        steps = 100;
    } else if(shift === true) {
        steps = 1;
    } else {
        steps = 10;
    }
    //console.log("steps.5938:           . . . STEPS=",steps, " shift=",shift, " ctrl=",ctrl, " alt=",alt);
    return steps;
}




// UTIL: 
// Make a number more presentable
//     - If it is a integer, keep it that way
//     - if it's a float, truncate it to Fixed(2)
//
export function tidyNumber(numb) {
    if (!numb) return null;

    var out = numb;
    var str = numb.toString();
    if (str.length > 6) {
        // must be a float
        var f = parseFloat(str);
        out = f.toFixed(2);
    }

    //console.log("tidy.1431:    numb=",numb, " str=",str, " out=",out);
    return out;
}


// force store session to db if not localhost
//
export function reportSystemException() {
    if (true || (INFO.localhost === false)) {
        if (INFO.exception_mode === false) {        // do it only once
            console.error("exception.3462:    ! ! ! ! ! SYSTEM EXCPETION, WRITING LOG TO DB");
            INFO.exception_mode = true;
            INFO.validate_passed = true;
            CreateVirtualSession(INFO.email, INFO.uid, "exception");        // write it out
        };
    }
}